<template>
	<b-container fluid class="my-4">
		<loading-indicator v-if="loading && !this.appeal.id" class="my-5" />
		<error-alert v-else-if="error"> Error </error-alert>
		<b-container v-else-if="editing">
			<b-row>
				<b-col cols="12" class="mb-4">
					<appeal-form :appeal="appeal" :case-entity="caseEntity" :insurance-appeal-ids-object="insuranceAppealIdsObject" @cancel="editing = false" @saved="savedEdit">
						<template #header>
							<b-card-header>
								<div class="d-flex justify-content-between align-items-center">
									<span class="font-weight-bold">Edit Appeal</span>
									<b-button
										variant="danger"
										size="sm"
										@click="editing = false"
										title="Cancel"
										class="mb-0"
									>
										<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
									</b-button>
								</div>
							</b-card-header>
						</template>
					</appeal-form>
				</b-col>
			</b-row>
		</b-container>
		<div v-else>

		<b-row class="mb-4">
			<!-- First Column -->
			<b-col class="d-flex align-items-center justify-content-between">
				<!-- Level Details Button -->
				<b-button @click="showDetails = !showDetails" variant="secondary" class="mr-3">
				<span v-if="showDetails">Hide Details</span>
				<span v-else>Level Details</span>
				</b-button>

				<!-- DOS Details -->
				<div class="align-item-center text-right dos-details">
							<div class="d-flex">
								<div>
									<span>Begin DOS:</span>
									<span class="font-weight-bold">{{$filters.formatDate(caseEntity.admit_date)}}</span>
								</div>
								<div class="ml-3">
									<span>Due Date: </span>
									<span 
										v-if="this.appeal.due_date"
										:style="{ 
										fontWeight: 'bold', 
										color: this.caseEntity?.closed === null ? this.appeal.is_overdue : 'black' 
										}">
										{{$filters.formatDate(this.appeal.due_date)}}
									</span>
									</div>

							</div>

							<div class="d-flex mt-2">
								<div>
									<span>End DOS&nbsp;&nbsp;&nbsp;:</span>
									<span class="font-weight-bold">{{$filters.formatDate(caseEntity.discharge_date)}}</span>
								</div>

								<div>
									<div class="ml-3 d-flex" v-if="appeal.submitted">
										<span>Last Sent Date:</span>
										<div class="d-flex">
											<!-- <span :class="['font-weight-bold', {'text-primary':  checkForModifiedLastSentDate || myoutgoing.length === 0}]">&nbsp;{{$filters.formatDate(appeal.submitted)}}</span> -->
											<span
												:class="['font-weight-bold']"
												:style="checkForModifiedLastSentDate ? { color: '#0d6efd'} : (appeal.submitted && myoutgoing.length === 0) ? { color: '#6f42c1'} : { color: '#000'}"
												>
												&nbsp;{{$filters.formatDate(appeal.submitted)}}
											</span>


											<span class="font-weight-bold lastSentDateIcon" v-if="this.myoutgoing.name_of_submit_to">[{{this.myoutgoing.name_of_submit_to}}]</span>
											<span title="Edit Last Sent Date" class="lastSentDateIcon">
												<a href="#" v-b-modal.sent-date-modal @click.prevent>
													<font-awesome-icon :icon="['fas', 'edit']" />
												</a>
											</span>										
										</div>
									</div>
								</div>
								<!-- modal to enter custom last sent date -->
								<!-- <b-modal id="sent-date-modal" title="Edit Last Sent Date" @ok="updateSentDate" ok-title="Save" cancel-title="Cancel">
									<div class="d-block">
										<label for="submittedDate">Select Date</label>
										<input type="date" v-model="submittedDate" id="submittedDate" class="form-control" />
									</div>
								</b-modal> -->
								<b-modal
									id="sent-date-modal"
									title="Edit Last Sent Date"
									@ok="updateSentDate"
									@hide="onModalClose"
									header-bg-variant="primary"
 									header-text-variant="white"
									>
									<!-- Modal Body -->
									<div class="d-block">
										<label for="submittedDate">Select Date</label>
										<input
										type="date"
										v-model="submittedDate"
										id="submittedDate"
										class="form-control"
										/>
									</div>

									<!-- Custom Footer: Cancel on Left, Save on Right -->
									<template #modal-footer="{ ok, cancel }">
										<div class="d-flex justify-content-between w-100">
										<b-button variant="outline-danger" style="width:76px;" @click="cancelLastSentEdit(cancel)">Cancel</b-button>
										<b-button variant="outline-primary" style="width:76px;" @click="ok()">Save</b-button>
										</div>
									</template>
									</b-modal>

							</div>
						</div>


				<!-- Request Button -->
				<b-dropdown
				split
				split-variant="outline-secondary"
				variant="secondary"
				class="requestDrpdwn"
				style="background-color: #fff1e6;"
				>
				<template #button-content>
					<span>Request</span>
					<b-badge
					pill
					v-if="!isRequest && filteredCaseRequestsLength > 0 || addingRequest"
					v-text="getOpenRequest"
					size="sm"
					class="ml-2"
					/>
				</template>
				<b-dropdown-item @click="openRequest" v-if="isButton || addingRequest">
					Show Request
				</b-dropdown-item>
				<b-dropdown-item
					@click="openForm"
					:disabled="addingRequest || appeal.appeal_status === 'Closed'"
					:title="appeal.appeal_status === 'Closed' ? 'Request cannot be created as appeal level is closed' : ''"
				>
					Add Request
				</b-dropdown-item>
				</b-dropdown>
			</b-col>
			<!-- Second Column with Edit Appeal and Cog Together on the Right -->
			<b-col class="d-flex justify-content-between align-items-center">
				<!-- Assign User Component -->
				<div style="margin-top: 15.5px; ">
			<appeal-assign :appeal="appeal" @assigned="assignedAppeal"/>
				</div>   
				
				<!-- Edit Appeal Button -->
				<div class="editappeal">
				<b-button
				@click="editing = true"
				:disabled="caseClosed"
				variant="outline-primary"
				:title="caseClosed ? 'This case is closed' : 'Edit appeal details'"
				v-if="appeal.appeal_status !== 'Closed'"
				>
				<font-awesome-icon icon="edit" fixed-width />
				Edit Appeal
				</b-button>

				<!-- Appeal Options Dropdown (Cog) -->
				<b-dropdown variant="secondary" right>
				<template #button-content>
					<font-awesome-icon icon="cog" fixed-width />
				</template>
				<b-dropdown-item v-if="appeal.appeal_status !== 'Closed'" @click="checkForOpenRequest">
					<font-awesome-icon icon="lock" fixed-width />
					Close Appeal
				</b-dropdown-item>
				<b-dropdown-item @click="cancelAppeal" :disabled="caseClosed || !canCancel || cancelling">
					<font-awesome-icon icon="ban" fixed-width />
					Cancel Appeal
				</b-dropdown-item>
				<b-dropdown-item
					v-if="appeal.appeal_status === 'Closed'"
					@click="reopenAppeal"
					:disabled="caseClosed || !canReopen || reopening"
				>
					<font-awesome-icon icon="envelope-open" fixed-width />
					Reopen Appeal
				</b-dropdown-item>
				<!-- modal for close appeal button -->
						<b-modal v-model="showCloseAPpealModal"
							title="Close Appeal" 
							@hide="hideCloseAppealModal" 
							@hidden="resetForm"
							header-bg-variant="primary" centered
							header-text-variant="white"
							>
							<b-list-group>
								<b-list-group-item>
									<b-row class="mb-8">
										<b-col cols="12" md="6" lg="6" xl="6" class="text-left relative mb-4">
											<b-form-group :label="`Decision Options`"
												label-cols-lg="5" class="mb-0">
												<b-form-select v-model="dynamicDecisionOption"
															:options="decisionOptionArr"
															class="mt-2"
															@shown="dropdownOpened = true" @hidden="dropdownOpened = false"
															>
												</b-form-select>
											</b-form-group>
										</b-col>
										<b-col v-if="showDenialAmount" cols="12" md="6" lg="6" xl="6" class="text-left relative">
											<b-form-group label="Decision Amount" label-cols-lg="5" class="mb-0">
												<b-form-input class="mt-2" v-model="riskAmount"></b-form-input>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="12" md="12" lg="12" xl="12" class="text-left relative mb-4">
										<b-form-group label="Appeal closure reasons" label-cols-lg="5" class="mb-0 mt-2">
											<div v-for="reason in appealClosureReasons" :key="reason.id" class="form-check">
												<b-form-checkbox 
													v-model="selectedClosureReasons" 
													:value="reason.name"
													@change="handleCheckboxChange(reason.name)">
													{{ reason.name }}
												</b-form-checkbox>
											</div>
											<b-form-input 
												v-if="selectedClosureReasons.includes('Other')" 
												class="mt-2 custom-input" 
												v-model="otherClosureReason" 
												placeholder="Please specify other closure reason..." 
												:state="!!otherClosureReason" 
												aria-describedby="closureReasonFeedback">
											</b-form-input>
											<b-form-invalid-feedback id="closureReasonFeedback">
												Closure reason is required.
											</b-form-invalid-feedback>
										</b-form-group>
									</b-col>



									</b-row>
								</b-list-group-item>
							</b-list-group>
							<template v-slot:modal-footer>
								<div class="w-100 d-flex justify-content-between">
									<b-button variant="secondary" @click="hideCloseAppealModal">Cancel</b-button>
									<b-button variant="primary" @click="handleOkButtonClick">OK</b-button>
								</div>
							</template>

						</b-modal>

						<b-dropdown-divider />

						<b-dropdown-item
							variant="danger"
							@click="deleteAppeal"
							:disabled="deleting || caseClosed || !canDelete"
						>
							<font-awesome-icon icon="trash" fixed-width />
							<span>Delete Appeal</span>
						</b-dropdown-item>
				</b-dropdown>
				</div>
			</b-col>
		</b-row>

			<b-collapse v-model="showDetails">
				<appeal-summary :appeal="appeal" :caseEntity="caseEntity" class="mb-4" />
			</b-collapse>
			
		<!--for add request -->
		<b-row v-if="addingRequest" class="my-2">
			<b-col cols="6">
				<case-request-form :case-entity="caseEntity" :caseRequestAppeal="appeal" @saved="addedRequest" @cancel="addingRequest = false; isAppeal = true">
					<template #header>
						<b-card-header>
							<div class="d-flex justify-content-between align-items-center">
								<span class="font-weight-bold">Add New Request</span>
								<b-button
									variant="danger"
									size="sm"
									@click="addingRequest = false"
									title="Cancel"
									class="mb-0"
								>
									<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
								</b-button>
							</div>
						</b-card-header>
					</template>
				</case-request-form>
			</b-col>
		</b-row>
		<!--request section start here-->
		<b-row v-if="isRequest && addingRequest === false">
			<b-col cols="6"  class="mb-2">
				<b-card no-body>
					<b-tabs card active-nav-item-class="font-weight-bold">
    <b-tab style="background-color: #fff1e6;">
        <template #title>Requests
			<b-badge
				pill
				v-if="filteredCaseRequestsLength && filteredCaseRequestsLength > 0"
				variant="primary"
				v-text="getOpenRequest"
				size="sm"
			/>		
		</template>
        <b-card v-if="filteredCaseRequests.length > 0" style="background-color: white;">
    <b-nav card-header tabs class="d-flex mb-2">
        <b-nav-item
            v-for="caseRequest in filteredCaseRequests"
            :key="'request_' + caseRequest.id"
            :to="{ params: { id: caseEntity.id, case_request_id: caseRequest.id } }"
            :title="caseRequest.name ? caseRequest.name : '(Missing Name)'"
            active-class="active font-weight-bold"
            @click="handleTabClick(caseRequest)"
            :class="['m-1', 
                { 
                    'text-white': caseRequest.id === selectedCaseRequestId,
                    'custom-border': caseRequest.id === selectedCaseRequestId,
                }
            ]"
            v-if="caseRequest.appeal_level == appeal.id"
            :ref="'request_' + caseRequest.id"
        >
            <case-request-status-label 
                v-if="caseRequest.appeal_level == appeal.id" 
                icon 
                :value="{
                    request_status: caseRequest.request_status,
                    status_label: caseRequest.status_label,
                    unable_to_complete: caseRequest.unable_to_complete,
					status: caseRequest.status,
                }" 
                class="d-none d-lg-inline mr-2" 
            />
            <span v-if="caseRequest.appeal_level == appeal.id && !caseRequest.type_label">Request</span>
            <span v-else-if="caseRequest.appeal_level == appeal.id">{{ caseRequest.type_label }}-{{ caseRequest.id }}</span>
        </b-nav-item>
    </b-nav>
</b-card>

        <!-- <b-row v-if="filteredCaseRequests.length > 0" class="mt-2 justify-content-end mr-4">
			<b-col class="d-flex justify-content-end align-items-center">
				<b-dropdown variant="secondary" right title="Request Options" :disabled="false" v-if="showRequestData">
					<template #button-content>
						<font-awesome-icon icon="cog" fixed-width />
					</template>
					<b-dropdown-item @click="editingRequest = !editingRequest" :disabled="deleting || appeal.appeal_status =='Closed'" v-if="isEditing">
						<font-awesome-icon icon="edit" fixed-width />
						Edit Request
					</b-dropdown-item>	

					<b-dropdown-item @click="setUTC" :disabled="deleting || updating || entity.completed || appeal.appeal_status =='Closed'">
						<font-awesome-icon icon="exclamation-triangle" fixed-width />
						<span v-if="entity.unable_to_complete">Remove Unable To Complete</span>
						<span v-else>Mark Unable To Complete</span>
					</b-dropdown-item>
					<b-dropdown-item @click="setRequestAsComplete" :disabled="deleting || updating || entity.completed || appeal.appeal_status =='Closed' || entity.status_label !=='Submitted'">
						<font-awesome-icon icon="exclamation-triangle" fixed-width />
						<span>Mark Response Received</span>
					</b-dropdown-item>

					<b-dropdown-divider />
					<b-dropdown-item @click="() => destroy(entity.id)" :disabled="deleting || appeal.appeal_status =='Closed'" variant="danger">
						<font-awesome-icon icon="trash" fixed-width />
						Delete Request
					</b-dropdown-item>
				</b-dropdown>
			</b-col>						
		</b-row> -->
		<empty-result v-if="filteredCaseRequests.length === 0" icon="check-circle">
			No Request
            <template #content>
                <p class="mb-0">No Requests Created.</p>
            </template>
        </empty-result>
		<!--For Editing Request-->
		<b-row v-if="editingRequest"  class="my-2">
			<b-col cols="12">
				<case-request-form 
				:id="entity.id"
				:entity="entity"
				:case-entity="caseEntity"
				:caseRequestAppeal="appeal"
				 @saved="updatedRequest"
				 @cancel="editingRequest = false">
					<template #header>
						<b-card-header>
							<div class="d-flex justify-content-between align-items-center">
								<span class="font-weight-bold">Edit Request</span>
							</div>
						</b-card-header>
					</template>
				</case-request-form>
			</b-col>
		</b-row>
	</br>
		<b-card>
		<div v-if="!editingRequest && showRequestData" ref="viewRequestSection">
								<b-row class="mt-2" v-if="filteredCaseRequests.length > 0">
									<b-col cols="12" lg="6" class="mb-2">
										<b-card :style="entity.type_label === 'Medical Records' ? { width: '360px', height: '350px', borderRightColor: 'transparent' } : { width: '360px', height: '280px', borderRightColor: 'transparent' }">
											<dl class="mb-0">
												<div class="row">
													<dt class="col-5 text-muted h6 small">Request ID</dt>
													<dd class="col-7">
														<span v-if="entity.id" class="text-primary font-weight-bold">{{ entity.id }}</span>
													</dd>
												</div>
												<div class="row">
													<dt class="col-5 text-muted h6 small">Details</dt>
													<dd class="col-7">
														{{ entity.name }}
													</dd>
												</div>

												<div class="row">
													<dt class="col-5 text-muted h6 small">Status</dt>
													<dd class="col-7">
														<!-- <case-request-status-label :value="filteredCaseRequests[0]" /> -->
														<!-- <case-request-status-label :value="entity.status_label" /> -->
														<case-request-status-label :value="entity.request_status" />
														
													</dd>
												</div>
												<div class="row">
													<dt class="col-5 text-muted h6 small">Type</dt>
													<dd class="col-7">
														{{ entity.type_label}}
													</dd>

												</div>
												<div class="row">
													<dt class="col-5 text-muted h6 small">Level</dt>
													<dd class="col-7">
														{{ appeal.insurance_provider_appeal_level.label}}
													</dd>

												</div>
												<div class="row">
													<dt class="col-5 text-muted h6 small" v-if="entity.type_label == 'Medical Records'">Assigned To</dt>
													<dt class="col-5 text-muted h6 small" v-if="entity.type_label != 'Medical Records'">Assigned To</dt>
													<dd class="col-7">
														
														<div v-if="entity.full_name">{{ entity.full_name}}</div>
														<div v-else class="text-muted">&mdash;</div>
													</dd>

												</div>
												<!-- <div class="row">
													<dt class="col-5 text-muted h6 small">Insurance Provider</dt>
													<dd class="col-7">
														<router-link
															v-if="entity.insurance_provider"
															:to="{
																name: 'insuranceProviders.view',
																params: { id: entity.insurance_provider_id },
															}"
														>
															{{ entity.insurance_provider.name }}
														</router-link>
														<div v-else class="text-muted">&mdash;</div>
													</dd>
												</div> -->
												<!-- <div class="row">
													<dt class="col-5 text-muted h6 small">Agency</dt>
													<dd class="col-7">
														<router-link
															v-if="entity.agency"
															:to="{
																name: 'agencies.view',
																params: { id: entity.agency_id },
															}"
														>
															{{ entity.agency.name }}
														</router-link>
														<div v-else class="text-muted">&mdash;</div>
													</dd>
												</div> -->
												<div class="row">
													<dt class="col-5 text-muted h6 small">Priority</dt>
													<dd class="col-7">
														<div v-if="entity.priority" class="text-primary font-weight-bold">
															Yes
														</div>
														<div v-else class="text-muted">No</div>
													</dd>
												</div>
												<div class="row" v-if="entity.type_label == 'Medical Records'">
													<dt  class="col-12 text-muted h6 small" style="font-weight: bolder;">
														<button @click="toggleNotesVisibility"
														class="badge badge-info badge-pill"  style="font-size: 100% !important; color: black !important; background-color: rgb(255, 199, 237) !important;">Notes</button>
													</dt>
													
												</div>
											</dl>
										</b-card>
									</b-col>
									<b-col cols="12" lg="6" class="mb-2">
										<b-card :style="entity.type_label === 'Medical Records' ? { height: '350px', borderLeftColor: 'transparent' } : { height: '280px', borderLeftColor: 'transparent' }">
											
											<dl class="mb-0">
												<div class="row">
													<dt class="col-5 text-muted h6 small" v-if="entity.type_label != 'Medical Records'">Days To Decision</dt>
													<dd class="col-3" v-if="entity.type_label != 'Medical Records'">
														{{ entity.day_to_decision}}
													</dd>
													<dd class="col-4" style="position:absolute; margin-left:239px; margin-top: -14px; z-index:  9999;">
												
															<b-dropdown variant="secondary" right title="Request Options" :disabled="false" v-if="showRequestData" class="ml-2">
																<template #button-content>
																	<font-awesome-icon icon="cog" fixed-width />
																</template>
																<b-dropdown-item @click="editingRequest = !editingRequest" :disabled="deleting || appeal.appeal_status =='Closed'"  v-if="isEditing">
																	<font-awesome-icon icon="edit" fixed-width />
																	Edit Request
																</b-dropdown-item>	

																<b-dropdown-item @click="setUTC" :disabled="deleting || updating || entity.completed || appeal.appeal_status =='Closed'">
																	<font-awesome-icon icon="exclamation-triangle" fixed-width />
																	<span v-if="entity.unable_to_complete">Remove Unable To Complete</span>
																	<span v-else>Mark Unable To Complete</span>
																</b-dropdown-item>
																<b-dropdown-item @click="setMarkUrgent" v-if="$authUser.id === entity.assigned_to && entity.type_label == 'Medical Records'" >
																	<svg  xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="23" height="16" fill="#000">
  																		<path d="M13,2.051V1a1,1,0,0,0-2,0V2.051A10.98,10.98,0,0,0,3.681,20.176,3.024,3.024,0,0,0,2,23a1,1,0,0,0,2,0,1.2,1.2,0,0,1,1.11-1.229.932.932,0,0,0,.2-.062,10.924,10.924,0,0,0,13.39,0,1.033,1.033,0,0,0,.182.064A1.2,1.2,0,0,1,20,23a1,1,0,0,0,2,0,3.024,3.024,0,0,0-1.681-2.824A10.98,10.98,0,0,0,13,2.051ZM3,13a9,9,0,1,1,9,9A9.011,9.011,0,0,1,3,13Z"/>
  																		<path d="M19.215,0a1,1,0,0,0,0,2A2.59,2.59,0,0,1,22,4.5a1,1,0,0,0,2,0A4.6,4.6,0,0,0,19.215,0Z"/>
  																		<path d="M2,4.5A2.59,2.59,0,0,1,4.785,2a1,1,0,0,0,0-2A4.6,4.6,0,0,0,0,4.5a1,1,0,0,0,2,0Z"/>
  																		<path d="M13,11.586V7a1,1,0,0,0-2,0v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414Z"/>
																	</svg>
																	<span v-if="entity.urgent">Remove Urgent</span>
																	<span v-else>Mark Urgent</span>
																</b-dropdown-item>
																<!-- add Response received item on view section* -->
																<b-dropdown-item v-if="entity.type_label != 'Medical Records'" @click="setRequestAsComplete" :disabled="deleting || updating || entity.completed || appeal.appeal_status =='Closed' || entity.status_label !=='Submitted'">
																	<font-awesome-icon icon="exclamation-triangle" fixed-width />
																	<span>Mark Response Received</span>
																</b-dropdown-item>

																<b-dropdown-divider />
																<b-dropdown-item @click="() => destroy(entity.id)" :disabled="deleting || appeal.appeal_status =='Closed'" variant="danger" v-if="isEditing">
																	<font-awesome-icon icon="trash" fixed-width />
																	Delete Request
																</b-dropdown-item>
															</b-dropdown>
													</dd>
												</div>
												<div class="row" v-if="entity.type_label != 'Medical Records'">
													<dt class="col-5 text-muted h6 small">Days To Respond</dt>
													<dd class="col-7">
														{{ entity.day_to_respond}}
													</dd>
												</div>
												<!-- <div class="row">
													<dt class="col-5 text-muted h6 small">Last Updated</dt>
													<dd class="col-7">
														<p :title="$filters.formatTimestamp(entity.modified)" class="mb-0">
															{{ $filters.fromNow(entity.modified) }}
														</p>
														<p
															v-if="entity.modified_by && entity.modified_by_user"
															class="small text-muted mb-0"
														>
															by {{ entity.modified_by_user.full_name }}
														</p>
													</dd>
												</div> -->
												<div class="row">
													<dt class="col-5 text-muted h6 small">Due Date</dt>
													<dd class="col-7" v-if="entity.type_label != 'Medical Records'">
														<span v-if="entity.due_date">
															{{ $filters.fromNow(entity.due_date) }} on
															{{ $filters.formatDate(entity.due_date) }}
														</span>
														<span v-else class="text-muted"> &mdash; </span>
													</dd>
													<dd class="col-7" v-if="entity.type_label == 'Medical Records'">
														<span v-if="entity.followUpDate">
															{{ $filters.fromNow(entity.followUpDate) }} on
															<br>{{ $filters.formatDate(entity.followUpDate) }}
														</span>
														<span v-else class="text-muted"> &mdash; </span>
													</dd>
												</div>
												<div class="row">
													<dt class="col-5 text-muted h6 small" title="Unable To Complete">
														UTC
													</dt>
													<dd class="col-7">
														<div v-if="entity.unable_to_complete" class="text-warning">
															Unable To Complete
														</div>
														<div v-else class="text-muted">No</div>
													</dd>
												</div>
												<div class="row" v-if="entity.type_label == 'Medical Records'">
													<dt class="col-5 text-muted h6 small" title="Urgent">
														Urgent
													</dt>
													<dd class="col-7">
														<div v-if="entity.urgent" class="text-urgent" style="color: #ff5252!important;font-weight: bold;">
															Urgent
														</div>
														<div v-else class="text-muted">No</div>
													</dd>
												</div>
												<!-- <div class="row">
													<dt class="col-5 text-muted h6 small">Completed</dt>
													<dd class="col-7">
														<span v-if="entity.completed" class="text-success">
															Completed {{ $filters.fromNow(entity.completed_at) }}
															<span v-if="entity.completed_by && entity.completed_by_user">
																by {{ entity.completed_by_user.full_name }}
															</span>
														</span>
														<span v-else class="text-muted"> &mdash; </span>
													</dd>
												</div> -->
												<!-- show submitted to for mr request -->
												<div class="row" v-if="entity.type_label == 'Medical Records'">
													<dt class="col-5 text-muted h6 small">Sent To</dt>
													<dd class="col-7">
														
														<div v-if="entity.submittedTo">{{ entity.submittedTo}}</div>
														<div v-else class="text-muted">&mdash;</div>
													</dd>

												</div>
												<div class="row" v-if="entity.type_label == 'Medical Records'">
													<dt class="col-5 text-muted h6 small">Name</dt>
													<dd class="col-7">
														
														<div>{{sendToUserName}}</div>
														
													</dd>

												</div>
												<!-- <div>
													<label v-if="entity.request_status === 'Submitted' || (entity.type_label == 'Medical Records' && entity.request_status != 'Closed')">
															<span style="font-weight: bolder;" v-text="entity.type_label == 'Medical Records' ? 'Uploaded' : 'Response Received'"></span>
															<input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															 @change="setRequestAsComplete(1,entity.type_label)" 
															 :disabled="entity.status == '1' ? true : false"  
															 :checked="entity.status == '1'" 
															/>
															<span class="checkmark"></span>
													</label>
													<label v-if="entity.request_status === 'Closed' || (entity.type_label == 'Medical Records' && entity.request_status === 'Closed')">
															<span style="font-weight: bolder;" v-text="entity.type_label == 'Medical Records' ? 'Uploaded' : 'Response Received'"></span>
															<input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															 @change="setRequestAsComplete(1,entity.type_label)" 
															 :checked="entity.request_status === 'Closed'" 
															/>
															<span class="checkmark"></span>
													</label>
													
												</div> -->
												<div v-if="entity.submittedTo === 'User' || entity.type_label === 'Documentation' || entity.type_label === 'Hearing'">
												<div class="row" v-if="entity.request_status === 'Submitted' || (entity.type_label == 'Medical Records' && entity.request_status != 'Closed')">
													<dt class="col-5 text-muted h6 small" style="font-weight: bolder;" title="Verified">
														<span style="font-weight: bolder;" v-text="entity.type_label == 'Medical Records' ? 'Returned' : 'Response Received'"></span>
													</dt>
													<dd class="col-7">
														
														<div class="text-muted"><input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															 @change="handleCheckboxCompleteChange($event, entity)" 
															 :disabled="entity.status == '1' ? false : false"  
															 :checked="entity.status == '1'" 
															/>
															<span class="checkmark"></span></div>
													</dd>
												</div>
											</div>
											<div v-if="entity.submittedTo === 'User' || entity.type_label === 'Documentation' || entity.type_label === 'Hearing'">
												<div class="row" v-if="entity.request_status === 'Closed' || (entity.type_label == 'Medical Records' && entity.request_status === 'Closed')">
													<dt class="col-5 text-muted h6 small" style="font-weight: bolder;" title="Verified">
														<span style="font-weight: bolder;" v-text="entity.type_label == 'Medical Records' ? 'Returned' : 'Response Received'"></span>
													</dt>
													<dd class="col-7">
														
														<div class="text-muted"><input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															 @change="handleCheckboxCompleteChange($event, entity)" 
															 :checked="entity.request_status === 'Closed'" 
															/>
															<span class="checkmark"></span></div>
													</dd>
												</div>
												</div>
												<!-- <div>
													<label v-if="entity.status === '1' && entity.assigned_to === $authUser.id">
															<span style="font-weight: bolder;">Verified</span>
															<input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															 @change="setRequestMRAsClosed(1,entity.type_label)" 
															 :checked="entity.request_status === 'Closed'" 
															/>
															<span class="checkmark"></span>
													</label>
												</div> -->
												<div class="row" v-if="entity.status === '1' || entity.submittedTo === 'Facility'">
													<dt class="col-5 text-muted h6 small" style="font-weight: bolder;" title="Verified">
														Verified
													</dt>
													<dd class="col-7">
														
														<div class="text-muted"><input type="checkbox" 
															 :id="'responseReceived-' + entity.id"
															 :name="'responseReceived-' + entity.id"
															 class="response-checkbox mt-1" 
															  @change="handleCheckboxCloseMRChange($event, entity)"
															 :checked="entity.request_status === 'Closed'" 
															/>
															<span class="checkmark"></span></div>
													</dd>
												</div>
												<div class="row" v-if="entity.type_label == 'Medical Records'">
													<dt v-if="filteredAppealLastNotes!=null" class="col-5 text-muted h6 small" style="font-weight: bolder;" title="Verified">
														Note
													</dt>
													<dd class="col-7">
														
														<div class="text-muted" v-if="filteredAppealLastNotes!=null">{{filteredAppealLastNotes.notes}}</div>
													</dd>
												</div>
												 
												
												<!-- <div>
													<b-form-group>
													<b-form-checkbox
														v-model="isOn"
														switch
														:true-value="true"
														:false-value="false"
														@change="handleToggle"
													>
													{{ entity.status_label === 'Completed' ? 'Unmark Response Received' : (entity.status_label === 'Submitted' ? 'Mark Response Received' : '') }}
													</b-form-checkbox>
													</b-form-group>
												</div> -->
											</dl>
											</b-card>
											</b-col>
										</b-row>
										<add-note-form v-if="hasNotesV && entity.type_label == 'Medical Records' " ref="addNoteForm" @submit="addNote" :saving="addingNote" />
								<!-- {{appeal.appeal_notes}} -->
								<div v-if="hasNotesV">
								<div v-if="hasNotes" style="max-height:17rem" class="mt-2 overflow-y-auto">
									<transition-group name="fade">
										<div
											v-for="note in filteredAppealNotes"
											:key="note.id"
											class="px-2 py-2 my-4 shadow-sm rounded border"
										>
										
											<user-note
												:note-id="note.id"
												:user="note.created_by_user"
												:body="note.notes"
												:timestamp="note.created"
												:deletable="canDeleteNote(note)"
												:deleting="deletingNote == note.id"
												@delete="deleteNote"
											/>
										</div>
									</transition-group>
								</div>
							</div>
									</div>
									
									
								
								</b-card>
                    			</b-tab>


                            <b-tab no-body>
								<template #title>Files</template>
								<b-tabs card pills>
									<b-tab no-body>
										<template #title>Case Documents</template>
										<CaseFiles
											ref="caseFiles"
											:id="$route.params.id"
											:flush="false"
											:selected.sync="selectedCaseFiles"
										/>
									</b-tab>
									<b-tab no-body active>
										<template #title>Appeal Documents</template>
										<AppealFiles
											ref="appealFiles"
											:id="$route.params.appeal_id"
											:flush="false"
											:selected.sync="selectedAppealFiles"
										/>
									</b-tab>
									<b-tab no-body lazy>
										<template #title> Created Documents</template>
										
									</b-tab>
								</b-tabs>
								
							</b-tab>
							<b-tab no-body>
								<template #title>
									<span>Create</span>
								</template>
								<b-tabs card pills>
									<b-tab no-body lazy>
										<template #title>Cover Page</template>
										<appeal-cover-page :appeal="appeal" @saved="savedCoverPage" />
									</b-tab>

									<b-tab no-body lazy>
										<template #title>Template TEST PR TEST</template>
										<b-card-body>
											<empty-result>
												No templates
												<template #content> No appeal response templates created. </template>
											</empty-result>
										</b-card-body>
									</b-tab>
									<b-tab no-body lazy>
										<template #title>Forms</template>
										<b-card-body>
											<b-list-group>
												<b-list-group-item
													href="https://www.hhs.gov/sites/default/files/omha-100.pdf"
													target="_blank"
												>
													<font-awesome-icon icon="file-pdf" fixed-width />
													OMHA-100
												</b-list-group-item>
											</b-list-group>
										</b-card-body>
									</b-tab>
							</b-tabs>
							</b-tab>
							<b-tab >
								<!-- <template #title>{{notesTabName}}</template> -->
								<add-note-form ref="addNoteForm" @submit="addNote" :saving="addingNote" />
								<!-- {{appeal.appeal_notes}} -->
								<div v-if="hasNotes" style="max-height:17rem" class="mt-2 overflow-y-auto">
									<transition-group name="fade">
										<div
											v-for="note in filteredAppealNotes"
											:key="note.id"
											class="px-2 py-2 my-4 shadow-sm rounded border"
										>
										
											<user-note
												:note-id="note.id"
												:user="note.created_by_user"
												:body="note.notes"
												:timestamp="note.created"
												:deletable="canDeleteNote(note)"
												:deleting="deletingNote == note.id"
												@delete="deleteNote"
											/>
										</div>
									</transition-group>
								</div>
						</b-tab>

						<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button v-if="!disableCancel" block variant="ligth" class="btn btn-outline-danger" @click="remove">Back To Appeal</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4" v-if="filteredCaseRequests.length > 0 && this.entity.type_label === 'Hearing'|| this.entity.type_label === 'Documentation'">
							<b-button
								block
								variant="ligth"
								@click="ispacket = !ispacket"
								:disabled="appeal.appeal_status =='Closed' || request_name == 'MedicalRecord'"
								class="btn btn-outline-success"
							>
							<font-awesome-icon :icon="ispacket ? 'minus' : 'plus'" fixed-width />
                            <span>Packet</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
										</b-tabs>	
			    </b-card>
            </b-col>
			<b-col cols="6" v-if="ispacket" >
					<b-card no-body active>
						<b-tabs card active-nav-item-class="font-weight-bold">
							<!-- <b-tab no-body style="background-color: #E6FFF2;"> -->
							<b-tab no-body style="background-color: #fff1e6;">
								<template #title>Build</template>
								<appeal-response
									:value="appeal"
									:appeal-files="selectedAppealFiles"
									:case-files="selectedCaseFiles"
									:request_name="request_name"
									:isDenialDataAvailable="isDenialDataAvailable"
									:isFinancialDataAvailable="isFinancialDataAvailable"
									:isPreAppealLevel="isPreAppeal"
									:appealName="appealName"
									show-case-files
									@submitted="appealPacketSubmitted"
									@remove="unselectFile"
									@submitPacketResponse="submitPacketResponse"
									@submitPacketHistoryResponse="submitPacketHistoryResponse"
									@rebillPacket="packetSubmittedAsRebill"
									@updateDecisionOption="updateDecisionOptionAfterRebill"
									@initialDenialAmountEnable="initialDenialAmountEnable"
									:request_id="request_id"
									:case-entity="caseEntity"
								/>
							</b-tab>
							
							
							<b-tab no-body>
								<template #title>
									<span>UTC</span>

									<b-badge variant="warning" v-if="appeal.unable_to_complete === true" pill>
										<font-awesome-icon icon="exclamation-triangle" class="mx-0 px-0" />
									</b-badge>
								</template>
								<appeal-utc :appeal="appeal" @saved="updatedUtc" disable-cancel />
							</b-tab>

							<b-tab v-if="hasIncomingDocuments" no-body lazy>
								<template #title>Incoming</template>
								<b-alert show variant="info" class="rounded-0 mb-0">
									<font-awesome-icon icon="info-circle" fixed-width />
									Incoming documents are copied to this appeal's files when attaching.
								</b-alert>
								<b-tabs v-if="appeal.incoming_documents.length > 0" card pills lazy vertical>
									<b-tab v-for="document in appeal.incoming_documents" :key="document.id" no-body>
										<template #title>
											<span>{{ $filters.formatTimestamp(document.created) }}</span>
										</template>
										<pdf-frame v-if="document.preview_url" :url="document.preview_url" />
									</b-tab>
								</b-tabs>
								<empty-result v-else>
									No attached documents
									<template #content>
										<p>Documents can be attached from Incoming Documents.</p>
									</template>
								</empty-result>
							</b-tab>
						
						
							<b-tab no-body>
								<template #title>Collaborate</template>

								<b-tabs card pills active-nav-item-class="font-weight-bold">
									<b-tab title="Guest Portal" no-body>
										<appeal-guest-portal
											:appeal="appeal"
											:case-entity="caseEntity"
											@saved="addedPortal"
										/>
									</b-tab>
									<b-tab v-if="enableVendorService">
										<template #title>
											{{ serviceName }}
											<b-badge variant="light">Pro</b-badge>
										</template>
										<appeal-vendor-stages
											:appeal="appeal"
											:case-entity="caseEntity"
											@saved="updatedAppeal"
											@submitted="submittedAppeal"
											@reopened="reopenedAppeal"
											@closed="closedAppeal"
										/>
									</b-tab>
								</b-tabs>
							</b-tab>
							
						</b-tabs>
					</b-card>
				</b-col>
			
		</b-row>
		<!--appeal section start here-->
			<b-row v-if="isAppeal && isRequest === false">
				<b-col cols="12" md="12" lg="6" >
					<b-card no-body>
						<b-tabs card active-nav-item-class="font-weight-bold">
							<b-tab no-body>
								<template #title>Files</template>
								<b-tabs card pills>
								<b-tab no-body style="min-height: 821px;">
                                <template #title>Case Documents </template>
								<CaseFiles
									ref="caseFiles"
									:id="$route.params.id"
									:flush="false"
									:selected.sync="selectedCaseFiles"
									class="mt-4"
								/>
							    </b-tab>
								<b-tab no-body active style="min-height: 821px;">
								<template #title>Appeal Documents</template>
								<AppealFiles
									ref="appealFiles"
									:id="$route.params.appeal_id"
									:flush="false"
									:selected.sync="selectedAppealFiles"
									:packet-created="packetCreated"
									:cancel-selection="cancelSelection"
 									@reset-cancel-flag="cancelSelection = false"
									@update-cancel-selection="cancelSelection = $event"
									@destroy-packet="destroyExistingPacket"
								/>
								
							</b-tab>
							<b-tab no-body style="min-height: 821px;">
								<template #title>Other Documents</template>
								<AppealFilesOther
									ref="AppealFilesOther"
									:id="$route.params.appeal_id"
									:flush="false"
									:selected.sync="selectedAppealFiles"
								/>
								
							</b-tab>
							<!-- <b-tab no-body lazy>
								<template #title> Created Documents</template>
								
							</b-tab> -->

								</b-tabs>
								
							</b-tab>
							<b-tab no-body>
								<template #title>
									<span>Create</span>
								</template>
								<b-tabs card pills>
									<b-tab no-body lazy>
										<template #title>Cover Page</template>
										<appeal-cover-page :appeal="appeal" @saved="savedCoverPage" />
									</b-tab>

									<b-tab no-body lazy>
										<template #title>Template</template>
										<b-card-body>
											<empty-result>
												No templates
												<template #content> No appeal response templates created. </template>
											</empty-result>
										</b-card-body>
									</b-tab>
									<b-tab no-body lazy>
										<template #title>Forms</template>
										<b-card-body>
											<b-list-group>
												<b-list-group-item
													href="https://www.hhs.gov/sites/default/files/omha-100.pdf"
													target="_blank"
												>
													<font-awesome-icon icon="file-pdf" fixed-width />
													OMHA-100
												</b-list-group-item>
											</b-list-group>
										</b-card-body>
									</b-tab>
							</b-tabs>
							</b-tab>
							<b-tab >
								<template #title>Notes</template>
								<add-note-form ref="addNoteForm" @submit="addNote" :saving="addingNote" />
								<!-- {{appeal}} -->
								<div v-if="hasNotes" style="max-height:17rem" class="mt-2 overflow-y-auto">
									<transition-group name="fade">
										<div
											v-for="note in filteredAppealNotess"
											:key="note.id"
											class="px-2 py-2 my-4 shadow-sm rounded border"
										>
											<user-note
												:note-id="note.id"
												:user="note.created_by_user"
												:body="note.notes"
												:timestamp="note.created"
												:deletable="canDeleteNote(note)"
												:deleting="deletingNote == note.id"
												@delete="deleteNote"
											/>
										</div>
									</transition-group>
								</div>
						    </b-tab>
						    <b-tab >
								<template #title>History</template>
								
								<!-- {{appeal}} -->
								<AppealFilesSubmitHistory
											ref="AppealFilesSubmitHistory"
											:id="$route.params.appeal_id"
											:flush="false"
											:selected.sync="selectedAppealFiles"
										/>
						    </b-tab>
							<b-tab class="ml-auto" v-if="isPreAppeal" >
								<template #title>
									<span :style="{ color: isDenialDataAvailable ? 'green' : 'red' }">Denials</span>
								</template>
								<b-row>
									<b-col cols="5" md="5">
										<b-form-group 
										label="Denial Type" 
										label-for="denial_type_id" 
										label-cols-lg="5"
										class="d-flex align-items-center"  
										>
										<b-form-select
											name="denial_type_id"
											v-model="denialData.denial_type_id"
											:options="denialTypes"
											:disabled="saving || loadingDenialTypes"
											value-field="id"
											text-field="name"
											class="w-80"  
										>
											<template #first>
											<option :value="null">(None)</option>
											</template>
										</b-form-select>
										</b-form-group>
									</b-col>

									<b-col cols="7" md="7">
										<b-form-group 
										label="Denial Reasons" 
										tabindex="1" 
										label-for="denial_reasons" 
										label-cols-lg="6"
										class="d-flex align-items-center"  
										>
										<b-form-select
											v-model="denialData.denial_reason_id"
											:options="entities"
											value-field="id"
											text-field="name"
											:disabled="saving"
											name="denial_reasons"
											class="w-100"  
										>
										</b-form-select>
										</b-form-group>
									</b-col>
								</b-row>
								<b-button
									v-if="showDenialSaveButton"
									variant="primary"
									@click="saveDenialData"
									:disabled="saving"
									class="ml-auto d-block"
								>
									Save Denial Details
								</b-button>
							</b-tab>
							<b-tab class="ml-auto" v-if="isPreAppeal" >
								<template #title> 
								<span :style="{ color: isFinancialDataAvailable ? 'green' : 'red' }">Financial</span>
								</template>
								<b-row>
									<b-col class="col-6">
									<validation-provider vid="total_claim_amount"
									name="Total Claim Amount" ref="totalClaimAmountValidationProvider"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Total Claim Amount"  label-for="total_claim_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="total_claim_amount" 
												v-model="caseEntity.total_claim_amount"
												:state="getValidationState(validationContext)" :min="0"
												step="0.00" maxlength="10" autocomplete="off" :read-only="entity.is_rebill"
											
												/>
												<b-form-invalid-feedback v-if="errors.length > 0" v-text="errors[0]" />
												<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col>
								<b-col class="col-6">
									<validation-provider vid="initial_denial_amount"
									name="Initial Denial Amount" ref="initialDenialAmountValidationProvider"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Initial Denial Amount" label-for="initial_denial_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="initial_denial_amount" 
												v-model="caseEntity.disputed_amount" :disabled="saving"
												:state="getValidationState(validationContext)"
												:min="0"
												step="0.00" maxlength="10" autocomplete="off"
												@input="validateTotalClaimAmount"
												/>
												<b v-if="errors.length > 0" style="color:red">{{ errors[0] }}</b>
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col>
								<b-col class="col-6">
									<validation-provider
									vid="disputed_amount"
									name="Level Denial Amount"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									ref="initialDisputedAmountValidationProvider"
									v-slot="validationContext"
								> 
									<b-form-group :label="`${levelName} Denial Amount`" label-for="disputed_amount" label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input
											name="disputed_amount"
											:value="levelName === 'Level I' ? caseEntity.disputed_amount : appeal.disputed_amount"
											@input="handleDisputedAmount"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											:min="0"
											:max="currencyMax"
											step="0.01"
											maxlength="10"
											autocomplete="off"
											:readonly="levelName === 'Level I'"
											/>
											<b v-if="errorsLevel.length > 0" style="color:red">{{ errorsLevel[0] }}</b>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col>
								</b-row>
								<b-row>
								<b-col class="md-12">
								
								<validation-provider v-if="iscontract" vid="contractRiskAmtCal" name="Contract Risk Amount(Calculated)"
									:rules="{ required: false, min_value: 0, max_value: entity.disputed_amount, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Calculated)" label-for="contract_paid_amt_est"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contractRiskAmtCal" type="number"
												v-model="contractRiskAmtCal" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.00" maxlength="10" autocomplete="off" readonly />
												<!-- <small class="form-text text-muted">
													<span>{{ caseEntity.facility.contract_pricing_schedules[caseEntity.insuranceRateType-1].contract_rate }} </span>
												</small> -->
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
												<!-- <span>{{ caseEntity.contract_pricing_schedules[caseEntity.insuranceRateType].contract_rate }} </span> -->
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col>
							<b-col class="md-12">
								
								<validation-provider v-if="iscontract" vid="contract_risk_amt_actual"
									name="Reimbursement Amount"
									:rules="{ required: false, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Actual)" label-for="contract_risk_amt_actual"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contract_risk_amt_actual" 
												v-model="entity.contract_risk_amt_actual" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="entity.disputed_amount"
												step="0.00" maxlength="10" autocomplete="off"  />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col>
								</b-row>
								<b-button
									variant="primary"
									@click="saveFinancialData"
									:disabled="saving"
									class="ml-auto d-block"
								>
									Save Financial  Details
								</b-button>
							</b-tab>
					    </b-tabs>
					</b-card>
				</b-col>
							
				<b-col cols="12" md="12" lg="6" >
					<b-card no-body active>
						<b-tabs card active-nav-item-class="font-weight-bold">
							<b-tab no-body>
								<template #title>Build</template>
									<appeal-response
									ref="appealResponse"
									:value="appeal"
									:appeal-files="selectedAppealFiles"
									:case-files="selectedCaseFiles"
									:case-entity="caseEntity"
									:isDenialDataAvailable="isDenialDataAvailable"
									:isFinancialDataAvailable="isFinancialDataAvailable"
									:isPreAppealLevel="isPreAppeal"
									:appealName="appealName"
									show-case-files
									@submitted="appealPacketSubmitted"
									@remove="unselectFile"
									@submitPacketResponse="submitPacketResponse"
									@submitPacketHistoryResponse="submitPacketHistoryResponse"
									@rebillPacket="packetSubmittedAsRebill"
									@updateDecisionOption="updateDecisionOptionAfterRebill"
									@initialDenialAmountEnable="initialDenialAmountEnable"
									@pdfdisable="isGenerating"
									@generated="packetGenerated"
									@atPacket="packetSelected"
									@reordered="isReordered"
									@packetSubmitted="packetSubmitted"
								/>
							</b-tab>
							<!--<b-tab no-body>
								<template #title>
									<span>Create</span>
								</template>
								<b-tabs card pills>
									<b-tab no-body lazy>
										<template #title>Cover Page</template>
										<appeal-cover-page :appeal="appeal" @saved="savedCoverPage" />
									</b-tab>

									<b-tab no-body lazy>
										<template #title>Template</template>
										<b-card-body>
											<empty-result>
												No templates
												<template #content> No appeal response templates created. </template>
											</empty-result>
										</b-card-body>
									</b-tab> 
									</b-tab> 
									<b-tab no-body lazy>
										<template #title>Forms</template>
										<b-card-body>
											<b-list-group>
												<b-list-group-item
													href="https://www.hhs.gov/sites/default/files/omha-100.pdf"
													target="_blank"
												>
													<font-awesome-icon icon="file-pdf" fixed-width />
													OMHA-100
												</b-list-group-item>
											</b-list-group>
										</b-card-body>
									</b-tab>
								</b-tabs>
							</b-tab> 
							</b-tab> -->
							<b-tab no-body>
								<template #title>
									<span>Defendable</span>

									<font-awesome-icon
										v-if="appeal.defendable === true"
										icon="check-circle"
										class="ml-1 pr-0 text-success"
									/>
									<font-awesome-icon
										v-else-if="appeal.defendable === false"
										icon="ban"
										class="ml-1 pr-0 text-danger"
									/>
								</template>
								<appeal-defendable :appeal="appeal" @saved="updatedDefendable" disable-cancel />
							</b-tab>
							<b-tab no-body>
								<template #title>
									<span>UTC</span>

									<b-badge variant="warning" v-if="appeal.unable_to_complete === true" pill>
										<font-awesome-icon icon="exclamation-triangle" class="mx-0 px-0" />
									</b-badge>
								</template>
								<appeal-utc :appeal="appeal" @saved="updatedUtc" disable-cancel />
							</b-tab>

							<b-tab v-if="hasIncomingDocuments" no-body lazy>
								<template #title>Incoming</template>
								<b-alert show variant="info" class="rounded-0 mb-0">
									<font-awesome-icon icon="info-circle" fixed-width />
									Incoming documents are copied to this appeal's files when attaching.
								</b-alert>
								<b-tabs v-if="appeal.incoming_documents.length > 0" card pills lazy vertical>
									<b-tab v-for="document in appeal.incoming_documents" :key="document.id" no-body>
										<template #title>
											<span>{{ $filters.formatTimestamp(document.created) }}</span>
										</template>
										<pdf-frame v-if="document.preview_url" :url="document.preview_url" />
									</b-tab>
								</b-tabs>
								<empty-result v-else>
									No attached documents
									<template #content>
										<p>Documents can be attached from Incoming Documents.</p>
									</template>
								</empty-result>
							</b-tab>
						<!--	<b-tab >
							<b-tab >
								<template #title>Notes</template>
								<add-note-form ref="addNoteForm" @submit="addNote" :saving="addingNote" />

								<div v-if="hasNotes" style="max-height:17rem" class="mt-2 overflow-y-auto">
									<transition-group name="fade">
										<div
											v-for="note in appeal.appeal_notes"
											:key="note.id"
											class="px-2 py-2 my-4 shadow-sm rounded border"
										>
											<user-note
												:note-id="note.id"
												:user="note.created_by_user"
												:body="note.notes"
												:timestamp="note.created"
												:deletable="canDeleteNote(note)"
												:deleting="deletingNote == note.id"
												@delete="deleteNote"
											/>
										</div>
									</transition-group>
								</div>
						</b-tab> 
						</b-tab> -->
							<b-tab no-body>
								<template #title>Collaborate</template>

								<b-tabs card pills active-nav-item-class="font-weight-bold">
									<b-tab title="Guest Portal" no-body>
										<appeal-guest-portal
											:appeal="appeal"
											:case-entity="caseEntity"
											@saved="addedPortal"
										/>
									</b-tab>
									<b-tab v-if="enableVendorService">
										<template #title>
											{{ serviceName }}
											<b-badge variant="light">Pro</b-badge>
										</template>
										<appeal-vendor-stages
											:appeal="appeal"
											:case-entity="caseEntity"
											@saved="updatedAppeal"
											@submitted="submittedAppeal"
											@reopened="reopenedAppeal"
											@closed="closedAppeal"
										/>
									</b-tab>
								</b-tabs>
							</b-tab>
							<!--Hearing tab-->
							<b-tab no-body>
                                <template #title>Hearing</template>
                              <b-card-body>
								<validation-provider
									vid="hearing_date"
									name="Hearing Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Hearing Date" label-for="hearing_date" label-cols-lg="4">
										<b-form-input
											name="hearing_date"
											type="date"
											v-model="hearing_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="hearing_time"
									name="Hearing Time"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Hearing Time" label-for="hearing_time" label-cols-lg="4">
										<b-form-input
											name="hearing_time"
											type="time"
											v-model="hearing_time"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<b-form-group label="Meeting Type" label-for="meeting_type" label-cols-lg="4">
      <b-form-select
        id="meeting_type"
        v-model="entity.meeting_type"
        :disabled="saving"
      >
        <option value="Location">Location</option>
        <option value="Telephonic">Telephonic</option>
        <option value="Video Conference">Video Conference</option>
      </b-form-select>
    </b-form-group>

    <!-- Render input based on selected Meeting Type -->
    <template v-if="entity.meeting_type === 'Location'">
      <b-form-group label="Address" label-for="address" label-cols-lg="4">
        <b-form-input
          id="address"
          v-model="entity.address"
          :disabled="saving"
        />
      </b-form-group>
    </template>
    <template v-else-if="entity.meeting_type === 'Telephonic'">
      <b-form-group label="Phone Number" label-for="phone_number" label-cols-lg="4">
        <b-form-input
          id="phone_number"
          v-model="entity.phone_number"
          :disabled="saving"
        />
      </b-form-group>
    </template>
    <template v-else-if="entity.meeting_type === 'Video Conference'">
      <b-form-group label="Conference URL" label-for="conference_url" label-cols-lg="4">
        <b-form-input
          id="conference_url"
          v-model="entity.conference_url"
          :disabled="saving"
        />
      </b-form-group>
    </template>
  </b-card-body>
								
				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button v-if="!disableCancel" block variant="light" @click="cancel">Cancel</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4">
							<b-button
								block
								variant="primary"
								type="submit"
								:disabled="saving"
								:title="invalid ? 'Please fix any validation errors' : 'Save'"
								@click="save"
							>
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span>Save</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
                              </b-tab>

						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
			<b-row> 
		<!--	<b-col  md="12" lg="6" class="mt-2 col" >
				<b-card  no-body>
				    <div >
						<nav class="d-flex justify-content-between align-item-center p-2 " style="background-color:#eeeeee;">
							<p class=" font-weight-bold h5 ml-4 align-item-center text-center" >Notes</p>
								<b-button @click="notesToggele();" class="bg-primary mr-3 "> 
									 
									<font-awesome-icon icon="plus" fixed-width />
							
						        </b-button>
						</nav>
                                <add-note-form ref="addNoteForm" @submit="addNote" :saving="addingNote" v-if="toggele" class="m-4"/>
								<div v-if="hasNotes"  style="max-height: 20rem" class="m-4  overflow-y-auto">
									<transition-group name="fade">
										<div
											v-for="note in appeal.appeal_notes"
											:key="note.id"
											class="px-2 py-2 my-4 shadow-sm rounded border"
										>
											<user-note
												:note-id="note.id"
												:user="note.created_by_user"
												:body="note.notes"
												:timestamp="note.created"
												:deletable="canDeleteNote(note)"
												:deleting="deletingNote == note.id"
												@delete="deleteNote"
											/>
										</div>
									</transition-group>
								</div>
					</div>		
				</b-card>
			</b-col> -->
		</b-row>
		</div>
	</b-container>
</template>

<style scoped>
.b-tabs.card .nav-tabs {
  background-color: red;
}
.custom-input {
    width: auto;
    display: inline-block;
    margin-left: 1rem; 
}

/* add no hover effect on request dropdown button */
.dropdown.b-dropdown.requestDrpdwn.btn-group .btn.btn-outline-secondary {
    pointer-events: none;
}
</style>

<script type="text/javascript">
import { mapGetters } from "vuex";

import AppealAssign from "@/clients/components/Appeals/Assign.vue";
import AppealCoverPage from "@/clients/components/Appeals/CoverPage.vue";
import AppealDefendable from "@/clients/components/Appeals/Defendable.vue";
import AppealFiles from "@/clients/components/Appeals/Files.vue";
import AppealForm from "@/clients/components/Appeals/Form.vue";
import AppealGuestPortal from "@/clients/components/Appeals/GuestPortal.vue";
import AppealResponse from "@/clients/components/Appeals/Response.vue";
import AppealStatusLabel from "@/clients/components/Appeals/StatusLabel.vue";
import AppealSummary from "@/clients/components/Appeals/Summary.vue";
import AppealUtc from "@/clients/components/Appeals/UnableToComplete.vue";
import AppealVendorStages from "@/clients/components/Appeals/VendorStages.vue";
import CaseIncomingDocument from "@/clients/components/Cases/IncomingDocument.vue";
import CaseFiles from "@/clients/components/Cases/Files.vue";

import AddNoteForm from "@/shared/components/AddNoteForm.vue";
import UserNote from "@/shared/components/UserNote.vue";
import PdfFrame from "@/shared/components/PdfFrame.vue";
import CaseRequestStatusLabel from "@/clients/components/CaseRequests/StatusLabel.vue";
import CaseRequestAssign from "@/clients/components/CaseRequests/Assign.vue";
import CaseRequestForm from "@/clients/components/CaseRequests/Form.vue";
import AttachCaseListItem from "@/clients/components/IncomingDocuments/AttachCaseListItem.vue";
import { formatErrors, getValidationState } from "@/validation";
import axios from "axios";
import { listSubmit } from "../../services/appealFiles";
import { EventBus  } from "../../services/eventBus";
import AppealFilesSubmitHistory from "@/clients/components/Appeals/SubmitPacketHistoryFile.vue";
import AppealFilesOther from "@/clients/components/Appeals/AppealFilesOther.vue";
import { nextTick } from 'vue';
import { isNullOrUndef } from "chart.js/helpers";

export default {
	name: "ViewAppeal",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					id: null,
					incoming_documents: [],
					appeal_reference_numbers: [],
					appeal_notes: [],
					appeal_type: {
						id: null,
						name: null,
					},
					guest_portals: [],
					unable_to_complete: null,
					can_cancel: false,
					can_delete: false,
					id : null,
					client_id: null,
					created: null,
					created_by: null,
					modified: null,
					modified_by: null,
					deleted: null,
					deleted_by: null,
					case_id: null,
					request_type: null,
					name: null,
					unable_to_complete: null,
					due_date: null,
					completed: null,
					completed_at: null,
					completed_by: null,
					assigned: null,
					assigned_to: null,
					assigned_to_user: null,
					insurance_provider_id: null,
					insurance_provider: null,
					agency_id: null,
					agency: null,
					// Virtual
					days_due_left: null,
					status_label: "",
					type_label: "",
					priority : null,
					closureReasons: []
				};
			},
		},
		caseEntity: {
			type: Object,
			default: () => {
				return {
					id: null,
					patient: {
						id: null,
						full_name: null,
					},
					closed: null,
					insurance_provider: null,
					insurance_type: null,
					admit_date:null,
					discharge_date:null,
				};
			},
		},
		enableVendorService: {
			type: Boolean,
			default: true,
		},
		disableCancel: {
			type: Boolean,
			default: false,
		},
		appealName: {
			type: String,
			default: null,
		},
		currencyMax: {
			type: Number,
			default: 999999999,
		},
	},
	components: {
		AppealAssign,
		AppealCoverPage,
		AppealDefendable,
		AppealFiles,
		AppealForm,
		AppealGuestPortal,
		AppealResponse,
		AppealStatusLabel,
		AppealSummary,
		AppealUtc,
		AppealVendorStages,
		CaseIncomingDocument,
		CaseFiles,
		AddNoteForm,
		UserNote,
		PdfFrame,
		CaseRequestStatusLabel,
		CaseRequestAssign,
		CaseRequestForm,
		AttachCaseListItem,
		AppealFilesSubmitHistory,
		AppealFilesOther,
	},
	computed: {
	levelName() {
			// if(this.appeal && this.appeal.id == null){
			// 	let levelName='Level';
			// 	this.insuranceData.forEach((item,index)=>{
			// 		if(this.entity.appeal_level_id===item.id){
			// 			levelName = item.label;
			// 		}
			// 	});
			// 	return levelName;
			// }
			// else{
			// 	return this.appeal?.insurance_provider_appeal_level?.label || 'Level';
			// }
			if (this.appeal?.is_rebill || false){
				return this.appeal.rebill_label || "Re-bill";
			}
			return this.appeal?.insurance_provider_appeal_level?.label || 'Level';
    },
	filteredAppealNotes() {
      if(this.request_id_for_notes == null) {
		return this.appeal.appeal_notes.filter(note => note.request_id == null);
	  } else {
		return this.appeal.appeal_notes.filter(note => note.request_id === this.entity.id);
	  }
    },
	filteredAppealNotess() {
		return this.appeal.appeal_notes.filter(note => note.request_id == null);
	 
    },
	filteredAppealLastNotes() {
      
		const filteredNotes = this.appeal.appeal_notes.filter(note => note.request_id === this.entity.id && note.created_by!=this.$authUser.id);
      	return filteredNotes.length > 0 
        	? filteredNotes[0] 
        	: null; 
	    },
		filteredCaseRequests() {
		return this.caseEntity.case_requests.filter(caseRequest => caseRequest.appeal_level === this.appeal.id);
    	//return this.caseEntity.case_requests.filter(caseRequest => {
        // if (caseRequest.appeal_level === this.appeal.id && this.$authUser.id === caseRequest.submittedTo_ID) {
        //     return true; 
        // } if (caseRequest.appeal_level === this.appeal.id &&
        //     this.$authUser.id === caseRequest.assigned_to &&
        //     this.$authUser.id === caseRequest.submittedTo_ID
        // ) {
        //     return true; 
        // } 
		// if (caseRequest.appeal_level === this.appeal.id &&
        //     this.$authUser.id === caseRequest.created_by
        // ) {
        //     return true; 
        // } 
    	//});
		},

		filteredCaseRequestsLength() {
			return this.filteredCaseRequests.length;
        },
		getOpenRequest(){

		let openRequestCount = this.caseEntity.case_requests.filter(caseRequest => {
    	return (
        caseRequest.appeal_level === this.appeal.id &&  
        caseRequest.request_status !== 'Closed'
    	);
		}).length;

		if (openRequestCount > 0) {
    		return openRequestCount;
		}
		},
		caseClosed() {
			return this.caseEntity.closed && this.caseEntity.closed !== null;
		},
		insuranceProvider() {
			if (!this.caseEntity || !this.caseEntity.insurance_provider) {
				return false;
			}

			return this.caseEntity.insurance_provider;
		},
		insuranceType() {
			if (!this.caseEntity || !this.caseEntity.insurance_type) {
				return false;
			}

			return this.caseEntity.insurance_type;
		},
		hasIncomingDocuments() {
			return this.appeal.incoming_documents && this.appeal.incoming_documents.length > 0;
		},
		hasReferenceNumbers() {
			return this.appeal.appeal_reference_numbers && this.appeal.appeal_reference_numbers.length > 0;
		},
		hasNotes() {
			
			for(let i=0;i<this.caseEntity.appeals.length;i++){
				
				if(this.caseEntity.appeals[i].id===this.appeal.id){
				
					return this.caseEntity.appeals[i].appeal_notes && this.caseEntity.appeals[i].appeal_notes.length > 0;
				}
			}
			return this.appeal.appeal_notes && this.appeal.appeal_notes.length > 0;
		},
		canCancel() {
			return this.appeal.can_cancel || false;
		},
		canDelete() {
			return this.appeal.can_delete || false;
		},
		canReopen() {
			return this.appeal.can_reopen || false;
		},
		...mapGetters({
			user: "user",
			serviceName: "vendorServiceName",
			denialTypes: "denialTypes/all",
			loadingDenialTypes: "denialTypes/loadingAll",
			entities: "denialReasons/all",
		}),
		isDataChanged() {
			return (
				this.denialData.denial_type_id !== this.originalDenialData.denial_type_id ||
				this.denialData.denial_reason_id !== this.originalDenialData.denial_reason_id
			);
		},
		isPreAppeal() {
			if(this.appeal.insurance_provider_appeal_level){
				if(this.appeal.insurance_provider_appeal_level.level_type === "Pre-Appeal"){
					return false;
				}
				return true;
			}
			else{
				return true;
			}
		},
		
		formattedHearingTime: {
      	get() {
			if (this.entity.hearing_time) {
          // Extract hours and minutes if hearing_time is not null
          const timeParts = this.entity.hearing_time.split(':');
          return `${timeParts[0]}:${timeParts[1]}`; // Return HH:MM format
        }
        return null; // Return null if hearing_time is null
      },
      set(value) {
        // Reformat the value back to original format if needed
		if(value) {
        this.entity.hearing_time = value + ':00.0000000'; // Append seconds and milliseconds
		} else {
			this.entity.hearing_time = null; // Append seconds and milliseconds
		}
      },
    },
	isRebillSelected() {
    	return this.selectedClosureReasons.includes('Re-bill');
  	},
	isRebill(){
		return this.appeal.is_rebill;
	},
	checkForModifiedLastSentDate() {
		return this.appeal.submitted &&
			this.myoutgoing.sent_date_time &&
			this.getModifiedLastSentDate() !==
			new Date(this.myoutgoing.sent_date_time).toISOString().split('T')[0];
	}


	},
	data() {
		return {
			
			appeal: this.value,
			loading: true,
			invalid: false,
			error: false,
			editing: false,
			editingRequest: false,
			cancelling: false,
			deleting: false,
			updating: false,
			reopening: false,
			addingNote: null,
			deletingNote: null,
			showDetails: false,
			selectedCaseFiles: [],
			selectedAppealFiles: [],
			toggele:false,
			entity: this.value,
			hearing_date: null,
			hearing_time: null,
			meeting_type: null,
			address: null,
			phone_number: null,
			conference_url: null,
			saving: false,
			addingRequest: false,
			isRequest: false,
			ispacket: false,
			isAppeal: true,
			isButton:true,
			isEditing:false,
			request_id:[],
			insuranceAppealIdsObject: {},
			selectedCaseRequestId: null,
			showRequestData:false,
			showCloseAPpealModal:false,
			dynamicDecisionOption: null,
			riskAmount: null,
			decisionOptionArr: [],
			appealClosureReason: null,
			showDenialAmount:true,
			appealClosureReasons: [], // This will hold the reasons fetched from the database
            selectedClosureReasons: [], // This will hold the selected reasons
            otherClosureReason: '', // This will hold the input for "Other"
			// closureReasons: [],
			request_name:'',
			name:'',
			caseassign:'',
			appealKey: 0,
			isDropdownOpen: false,
			isOn: false,
			myoutgoing:[],
			meeting_id:null,
			meeting_password:null,
			denialData:[],
			showDenialSaveButton:false,
			isPageLoaded:false,
			isDenialDataAvailable:false,
			status:null,
			sendToUserName:null,
			request_id_for_notes: null,
			notesTabName: null,
			hasNotesV:false,
			iscontract:null,
			showFinanceSaveButton:false,
			contractRiskAmtCal:null,
			isFinancialDataAvailable:false,
			errors: [],
			errorsLevel: [],
			rebilldata: null,
			rebillOutcomeCodes:['25','20'],
			packetCreated: false,
			currPacketName: '',
			atPacket: false,
			cancelSelection: false,
			showModal: false,
    		submittedDate: null,
			isSaved: false,
		};
	},
	
	mounted() {
		// this.submittedDate = this.appeal.submitted ? this.getModifiedLastSentDate() : null; 
		this.originalOutstandingAmount = this.appeal.outstanding_amount;
		this.originalDecision = this.dynamicDecisionOption;
		// // console.log("MOUNTED REFRESH CALLED");
		// // this.refresh();
		// // console.log("MOUNTED REFRESH executed");
		// this.hearing();
		// console.log("mounted case entity = ", this.caseEntity);
		// this.caseEntity.appeals.forEach(item => {
		// 	// Get the insurance_appeal_id for the current item
		// 	const insuranceAppealId = item.insurance_appeal_id;

		// 	// Check if the insurance_appeal_id exists in the object, if not, create an empty array
		// 	if (!this.insuranceAppealIdsObject[item.id]) {
		// 		this.$set(this.insuranceAppealIdsObject, item.id, []); // Use $set to ensure reactivity
		// 	}

		// 	// Push the insurance_appeal_id into the array corresponding to the current caseEntity
		// 	this.insuranceAppealIdsObject[item.id].push(insuranceAppealId);
		// });

		// console.log("VSCODE", this.insuranceAppealIdsObject);
		if(this.caseEntity.total_claim_amount && this.caseEntity.disputed_amount && this.appeal.disputed_amount){
			// if(this.caseEntity.total_claim_amount >= this.caseEntity.disputed_amount && this.caseEntity.total_claim_amount >= this.appeal.disputed_amount){
			if(this.caseEntity.total_claim_amount > 0 && this.caseEntity.disputed_amount > 0 && this.appeal.disputed_amount > 0){
				this.isFinancialDataAvailable = true;
			}
		}
		this.outgoingDetails();
		this.initializeData();
		
		this.fetchDenialTypesAndDenialReasons();
        // this.fetchAppealClosureReasonsAssociation();
		this.refresh();
		this.updateDueDate();

		// show request section direct
		if (this.$route.params.redirected === 'request') {
			
			this.openRequest();

			// const refName = 'request_' + this.$route.params.case_request_id;
			// const element = this.$refs[refName];

			const caseRequest = this.filteredCaseRequests.find(req => req.id === this.$route.params.case_request_id);

			this.triggerRequestTabClick(caseRequest);
		}
		this.isPageLoaded=true;
	},
	methods: {
		validateTotalClaimAmount() {
			
			const disputedAmount = Number(this.caseEntity.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			this.errors = [];
    		if (disputedAmount > totalClaimAmount) {
			this.errors.push('Initial Denial Amount must be less than or equal to the Total Claim Amount.');
			return false;
    		
		} else {
			// Clear any previous errors
      		this.errors = [];
      		return true;
    	}
  		},
		handleDisputedAmount(value) {
			if (this.levelName !== 'Level I') {
			this.appeal.disputed_amount = value;
			}
			const disputedAmount = Number(this.appeal.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			this.errors = [];
    		if (disputedAmount > totalClaimAmount) {
			this.errorsLevel.push('Level Denial Amount must be less than or equal to the Total Claim Amount.');
			return false;
    		
		} else {
			// Clear any previous errors
      		this.errorsLevel = [];
      		return true;
    	}
		},
		toggleNotesVisibility() {
      	this.hasNotesV = !this.hasNotesV;
    	},

		getSentoName(caseRequest) {
			axios.post('/client/getMRSentToUserName', {
				id: caseRequest.submittedTo_ID,
				submittedTo:caseRequest.submittedTo
			
			})
			.then(response => {
				this.sendToUserName = response.data.userName;
		
				
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
		getAssigntoName(caseRequest) {
			axios.post('/client/getMRAssignToUserName', {
				id:caseRequest.assigned_to
			
			})
			.then(response => {
				this.entity.full_name = response.data.userName;
		
				
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
		changeAppealStatus(newStatus) {
		// Emit the event with the new status

		EventBus.$emit('appealStatusChanged', { status: newStatus });
		},
		hideCloseAppealModal() {
      		this.resetForm();
		},
		resetForm() {
			this.dynamicDecisionOption = null;
			this.riskAmount = '';
			this.selectedClosureReasons = [];
			this.otherClosureReason = '';
		},
		async handleOkButtonClick() {
			// check for the open request for the appeal to be closed
			const response = await axios.get('/client/checkRquestStatus', {
				params: {
					caseId: this.appeal.case_id,
					appealLevel: this.appeal.id
				}
			});
			// this.searchResults = response.data;
			if(response.data.hasIncompleteRequests == false){
				this.hideCloseAPpealModal = false;
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "Close appeal",
						message: `Request still in progress....`,
					});
				});
			}else{
				if(this.selectedClosureReasons.includes('Re-bill')){
					this.dynamicDecisionOption = 'Re-bill';
					this.entity.is_rebill = true;
					//this.isFinancialDataAvailable = false;
				}
				this.updateDecisionOption(
					this.appeal.id,
					this.dynamicDecisionOption,
					this.riskAmount,
					this.selectedClosureReasons,
					this.otherClosureReason
				);
				this.hideCloseAPpealModal = false;
				this.refresh();
			}
		},
		// method to update appeal decision option for manual closure
		async updateDecisionOption(appeal, decisionOption, riskAmountValue, selectedClosureReasons,otherClosureReason) {
			try {
				// this.showButtons = false;

				// if (!appealClosureReason) {
				// 	this.$bvToast.toast('Closure reason is required.', {
				// 	title: 'Validation Error',
				// 	variant: 'danger',
				// 	solid: true
				// 	});
				// }else{
				// 	console.log("Decision options are", decisionOption);
				// 	console.log("Risk amount is", riskAmountValue);
				// 	console.log("Appeal", appeal);
				// 	console.log("closure reason", appealClosureReason);
				// selectedClosureReasons: this.selectedClosureReasons,
                // otherClosureReason: this.otherClosureReason

					const response = await axios.post('/client/savedecisionoption', {
						appealId: appeal,
						decisionOption: decisionOption,
						riskAmount: riskAmountValue,
						selectedClosureReasons: selectedClosureReasons,
						otherClosureReason: otherClosureReason
					});
					this.showCloseAPpealModal = false;
					this.$nextTick(function () {
						this.$store.dispatch("notify", {
							variant: "primary",
							title: "Close appeal",
							message: `Appeal closed.`,
						});
					});
					// 
					this.$emit("updated", response);
					this.refresh();
					this.changeAppealStatus('Closed');
					for(let i=0;i<selectedClosureReasons.length;i++){
						if(selectedClosureReasons[i]=='Re-bill'){
							this.packetSubmittedAsRebill(selectedClosureReasons);
							const response = await this.$store.dispatch("cases/close", {
								id: this.caseEntity.id,
								case_outcome_id: 20,
								settled_amount: null,
								case_outcome_other:null,
								case_outcome_info:null,
							});
							break;
						}
					}
				// this.refreshCase(appeal.case_id);

			} catch (error) {
				console.error('Error updating decision option:', error);
			}
		},
		submitPacketResponse(response) {
			this.$refs.appealFiles.updateComponent(response);
			this.refresh();
 
    	},
		initialDenialAmountEnable(response) {
			this.entity.is_rebill = false;
 
    	},
		submitPacketHistoryResponse(response) {
			this.$refs.AppealFilesSubmitHistory.updateComponent(response);
			this.refresh();
 
    	},
		packetSubmitted(){
			this.outgoingDetails();
			this.refresh();
		},

		isGenerating(response) {
			try {
				this.$refs.appealFiles.updateComponent(response);
			} catch (error) {
				console.error("Error updating appealFiles:", error);
			}

			try {
				this.$refs.caseFiles.updateComponent(response);
			} catch (error) {
				console.error("Error updating caseFiles:", error);
			}

		},

		// check for open request before closing any appeal
		async checkForOpenRequest(){
			// check for the open request for the appeal to be closed
			// console.log(JSON.stringify(this.appeal.insurance_provider_appeal_level.appeal_level_id));
			const response = await axios.get('/client/checkRquestStatus', {
				params: {
					caseId: this.appeal.case_id,
					appealLevel: this.appeal.id
				}
			});
			// this.searchResults = response.data;
			if(response.data.hasIncompleteRequests == false){
				this.hideCloseAPpealModal = false;
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "Submit Appeal",
						message: `All request must be closed first, prior to submitting an appeal.`,
					});
				});
			}else{
				// Now open the modal
				this.closeAppealModal();
			}
		},
		// modal click event methods
		closeAppealModal() {
			
			if(!this.isDenialDetailsAdded() && this.isPreAppeal){
				this.$store.dispatch("notify", {
								variant: "danger",
								title: "Denial Details Unavailable",
								message: "Enter denial details before closing the appeal.",
							});
				return;
			}
			if(!this.isFinancialDataAvailable && this.isPreAppeal){
				this.$store.dispatch("notify", {
								variant: "danger",
								title: "Financial Details Unavailable",
								message: "Enter Financial details before closing the appeal.",
							});
				return;
			}
			this.showCloseAPpealModal = true;
			this.decisionOptionArr =[];
			

		
			// this.caseEntity.appeals.forEach(item => {

			// });
			let matchedAppeal = this.caseEntity.appeals.find(appeal => appeal.id === this.value.id);
			// console.log('matchedAppeal is*:-');
			// console.log(JSON.stringify(matchedAppeal));
			if(matchedAppeal.insurance_provider_appeal_level.decision_options == 1){
				this.decisionOptionArr.push("No Findings");
				this.decisionOptionArr.push("Issues");
				this.showDenialAmount=false;
			}
			else if(matchedAppeal.insurance_provider_appeal_level.decision_options == 2){
				this.decisionOptionArr.push("Reversed");
				this.decisionOptionArr.push("Held");	
				this.showDenialAmount=false;
			}
			else if(matchedAppeal.insurance_provider_appeal_level.decision_options == 3){
				this.decisionOptionArr.push("Not Favorable");
				this.decisionOptionArr.push("Partially Favorable");
				this.decisionOptionArr.push("Favorable");
				
				this.this.showDenialAmount=true;
			}
		
		},
		hideCloseAppealModal(){
			this.showCloseAPpealModal = false;
		},
		/**
		 * Get Details
		 */
		 cancel(e) {
			if (e) {
				e.preventDefault();
			}

			this.$emit("cancel");
		},
		async refreshcaseEntity() {
			try {
				this.loading = true;
				this.error = false;

				const response = await this.$store.dispatch("caseRequests/get", {
					case_id: this.$route.params.id,
					// id: this.$route.params.case_request_id,
					id: this.request_id[(this.request_id).length-1],
				});
				this.request_id = [];
				this.entity = response;
			} catch (e) {
				this.error = true;
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to find request",
				});
			} finally {
				this.loading = false;
			}
		},
		async refreshcaseEntityStatus(id) {
			try {
				this.loading = true;
				this.error = false;

				const response = await this.$store.dispatch("caseRequests/get", {
					case_id: this.$route.params.id,
					// id: this.$route.params.case_request_id,
					id: id,
				});
				this.request_id = [];
				this.entity.request_status = response.request_status;
				this.entity.status=response.status;
				this.entity.id=response.id;
				this.entity.name=response.name;
				this.entity.followUpDate=response.followUp_date;
				this.entity.submittedTo=response.submittedTo;
				this.getSentoName(response);
			} catch (e) {
				this.error = true;
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to find request",
				});
			} finally {
				this.loading = false;
			}
		},
		async refresh() {
			try {
				this.loading = true;
				this.error = false;

				const response = await this.$store.dispatch("appeals/get", {
					id: this.$route.params.appeal_id,
				});

				this.appeal = response;

				const responseCase = await this.$store.dispatch("cases/get", {
					id: this.caseEntity.id,
				});
				this.iscontract = responseCase.facility.has_contract;
				this.caseEntity = responseCase;
				for(let i=0;i<this.caseEntity.appeals.length;i++){
					
					if(this.caseEntity.appeals[i].id === this.appeal.id){
						this.appeal = this.caseEntity.appeals[i];
					
						break;
					}
				}
				
				// Calling refresh function in the parent component at every refresh
				this.$emit("reopened", this.appeal);
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Unable to load appeal details",
				});

				this.error = e.response.data.message || "Unable to load appeal details";
			} finally {
				// Update appealKey to trigger a re-render
				this.appealKey += 1;
			
				this.$forceUpdate();
				
				this.loading = false;
			}
		},
		async refreshcaseEntityStatusMR(id) {
				this.error = true;
			try {
				this.loading = true;
				this.error = false;

				const response = await this.$store.dispatch("caseRequests/get", {
					case_id: this.$route.params.id,
					// id: this.$route.params.case_request_id,
					id: id,
				});
				this.request_id = [];
				this.entity.request_status = response.request_status;
				this.entity.status=response.status;
				this.entity.id=response.id;
				this.entity.name=response.name;
				this.entity.followUpDate=response.followUp_date;
				this.entity.full_name=response.assigned_to_user.full_name;
				this.getSentoName(response);
			} catch (e) {
				this.error = true;
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to find request",
				});
			} finally {
				this.loading = false;
			}
		},
		async setUTC() {
			try {
				this.updating = true;
				const newValue = !this.entity.unable_to_complete;

				const response = await this.$store.dispatch("caseRequests/setUtc", {
					case_id: this.$route.params.id,
					id: this.entity.id,  // Use entity.id instead of case_request_id
					unable_to_complete: newValue,
				});

				this.$emit("updated-request", response);

				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Request Marked UTC",
					message: "Case request UTC status updated",
					data: response,
				});

				// Update the entity with the new value
				this.entity.unable_to_complete = newValue; 
			}  catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to update request UTC status",
				});
			} finally {
				this.updating = false;
			}
		},
		async setMarkUrgent() {
			try {
				const newValue = !this.entity.urgent;

				const response = await this.$store.dispatch("caseRequests/setMarkUrgent", {
					case_id: this.$route.params.id,
					id: this.entity.id,  // Use entity.id instead of case_request_id
					urgent: newValue,
				});

				this.$emit("updated-request", response);

				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Request Marked Urgent",
					message: "Case request marked urgent status updated",
					data: response,
				});

				// Update the entity with the new value
				this.entity.urgent = newValue; 
			}  catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed to update request UTC status",
				});
			} finally {
				
			}
		},
		async updatedRequest(entity) {
			this.$emit("updated-request", entity);
			this.editingRequest = false;
			//this.refreshcaseEntity();
			this.refreshcaseEntityStatus(entity.id);
		},
		updatedAppeal(appeal, action = "") {
			if (appeal && appeal.id) {
				//this.$emit('update:appeal', appeal);
				this.$emit("saved", appeal);
			}

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal Updated",
				message: "Appeal updated successfully.",
			});

			this.refresh();
		},
		submittedAppeal(appeal) {
			if (appeal && appeal.id) {
				//this.$emit('update:appeal', appeal);
				this.$emit("saved", appeal);
			}

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal Submitted",
				message: "Appeal submitted successfully.",
			});

			this.refresh();
		},
		reopenedAppeal(appeal) {
			if (appeal && appeal.id) {
				//this.$emit('update:appeal', appeal);
				this.$emit("saved", appeal);
			}

			this.$emit("reopened", appeal);

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal Reopened",
				message: "Appeal reopened successfully.",
			});

			this.refresh();
		},
		closedAppeal(appeal) {
			if (appeal && appeal.id) {
				//this.$emit('update:appeal', appeal);
				this.$emit("saved", appeal);
			}

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal Closed",
				message: "Appeal closed successfully.",
			});

			this.refresh();
		},
		appealPacketSubmitted(response) {
			this.packetCreated = false;
			this.refresh();
			if(this.request_id.length > 0){
				this.refreshcaseEntity();
				// this.ispacket = false;
				// this.addingPacket = false;
			}
			// update selected File count in the Files.vue component
			this.$refs.appealFiles.setSelectedAppealFileCountToZero();
			
		},
		
		updatedDefendable(appeal) {
			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal Defendability Updated",
				message: "Appeal defendable status updated.",
			});

			this.refresh();
		},
		updatedUtc(appeal) {
			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Appeal UTC Updated",
				message: "Appeal UTC status updated.",
			});

			this.refresh();
		},
		assignedAppeal(response) {
			// var message = "Appeal assigned to open queue.";
			// if (response.assigned_to_user && response.assigned_to_user.full_name) {
			// 	message = `Appeal assigned to ${response.assigned_to_user.full_name}.`;
			// }

			// this.$store.dispatch("notify", {
			// 	variant: "primary",
			// 	title: "Appeal Assigned",
			// 	message: message,
			// });

			// this.$emit("update:appeal", response);
			this.refresh();
			if(this.entity.name != undefined) {
			this.refreshcaseEntityStatusMR(this.entity.id);
			}
		},
		async cancelAppeal() {
			const message = "Are you sure you want to cancel this appeal?";
			if (!confirm(message)) {
				return false;
			}

			try {
				this.cancelling = true;

				const response = await this.$store.dispatch("appeals/cancel", {
					id: this.appeal.id,
				});

				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Appeal Cancelled",
					message: `Appeal level ${this.appeal.insurance_provider_appeal_level.label || "(Unknown)"} was cancelled.`,
				});

				this.$emit("cancelled", response.data);
				this.refresh();
				this.changeAppealStatus('Cancelled');
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Cancel Failed",
					message: "Failed to cancel appeal",
				});
			} finally {
				this.initializeData();
				this.cancelling = false;
			}
		},
		async reopenAppeal() {
			const message = `Are you sure? This will reset the status to 'In Process' and cancel any progression.`;
			if (!confirm(message)) {
				return false;
			}

			try {
				this.reopening = true;

				const response = await this.$store.dispatch("appeals/reopen", {
					id: this.appeal.id,
				});
				// this.appeal.closureReasons = [];

				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Appeal Reopened",
					message: `Appeal level ${this.checkAppealName(this.caseEntity, this.appeal)} is reopened.`,
				});
				// if(this.entity.is_rebill) {
				// this.isFinancialDataAvailable = false;
				// }
				this.$emit("update:appeal", response);
				this.$emit("reopened", response);
				this.changeAppealStatus('In Process');
				this.refresh();
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Reopen Failed",
					message: "Failed to reopen appeal",
				});
			} finally {
				this.reopening = false;
			}
		},
		async deleteAppeal() {
			const message = "⚠️ Are you sure you want to delete this appeal? This will delete all the related Case Requests!";
			if (!confirm(message)) {
				return false;
			}

			try {
				this.deleting = true;

				// Cascading delete for case request
				for (const request of this.caseEntity.case_requests) {
					for (const request of this.caseEntity.case_requests) {
						const response = await this.$store.dispatch("caseRequests/delete", {
							case_id: this.caseEntity.id,
							id: request.id,
						});
					}
                }

				// const responseDeleteSubmittedDocuments = await axios.post('client/cancelSubmittedDocument', {appealId: this.appeal.id});

				const response = await this.$store.dispatch("appeals/delete", {
					id: this.appeal.id,
				});
				
				// const appealLevel = (response.data.appeal_level && response.data.appeal_level.name) || "(Missing)";
				const appealLevel = this.appeal.insurance_provider_appeal_level && this.appeal.insurance_provider_appeal_level.label 
				? this.appeal.insurance_provider_appeal_level.label 
				: "(Missing)";

				this.$emit("deleted", response.data);

				this.$router.push({
					name: "cases.view",
					params: {
						id: this.$route.params.id,
					},
				});

				this.$nextTick(() => {
					this.$store.dispatch("notify", {
						variant: "primary",
						title: "Appeal Deleted",
						message: `Appeal level & Case Requests ${appealLevel} were deleted.`,
					});
				});

				const deleteDenialTypeAndReasonResponse = await axios.post('/client/api/deleteDenialTypeAndDenialReasonForAppeal', {
					'appeal_id':this.appeal.id
				});
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Delete Failed",
					message: "Failed to delete appeal",
				});
			} finally {
				this.initializeData();
				this.deleting = false;
			}
		},
		/**
		 * Edit
		 */
		savedEdit(appeal) {
			this.editing = false;
			this.refresh();
			this.initializeData();
			this.$emit("updated", appeal);
		},
		/**
		 * Notes
		 */
		async addNote(note) {
			
			try {
				this.addingNote = true;

				const response = await this.$store.dispatch("appealNotes/addNote", {
					id: this.appeal.id,
					notes: note.notes,
					request_id:this.request_id_for_notes,
				});
				// Ensure this.appeal.appeal_notes is initialized as an array
				// if (!Array.isArray(this.appeal.appeal_notes)) {
				// 	this.appeal.appeal_notes = [];
				// }

				this.appeal.appeal_notes.unshift(response);
				if (this.$refs.addNoteForm) {
					this.$refs.addNoteForm.reset();
				}
                
				if(this.toggele==true){
				this.toggele = false;
				
			    }else{
				this.toggele=true;	
			}
                

			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Add Note Failed",
					message: "Failed to add appeal note",
				});
			} finally {
				this.addingNote = false;
				this.refresh();
			}
		},
		
		canDeleteNote(note) {
			if (!note || !note.id) return false;
			if (this.user.admin) return true;

			return note.created_by == this.user.id;
		},
		async deleteNote(noteId) {
			try {
				this.deletingNote = noteId;

				const response = await this.$store.dispatch("appealNotes/deleteNote", {
					appeal_id: this.appeal.id,
					id: noteId,
				});

				const index = this.appeal.appeal_notes.findIndex((note) => {
					return note.id == response.data.id;
				});

				if (index !== -1) {
					this.appeal.appeal_notes.splice(index, 1);
				}
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Delete Note Failed",
					message: "Failed to delete appeal note",
				});
			} finally {
				this.deletingNote = null;
				// this.refresh();
			}
		},
		/**
		 * Files
		 */
		unselectFile(selectedFile) {
			switch (selectedFile.source) {
				case "Appeal":
					const appealFileIdx = this.selectedAppealFiles.findIndex((file) => file == selectedFile.file);
					if (appealFileIdx !== -1) {
						this.selectedAppealFiles.splice(appealFileIdx, 1);
					}
					break;
					case "appealPacket":
					const cleanedFileNames = this.selectedAppealFiles.map(file => {
    							return file.split("~")[0];
					});	
					const appealPacketIdx = cleanedFileNames.findIndex((file) => file == selectedFile.file);
					if (appealPacketIdx !== -1) {
						this.selectedAppealFiles.splice(appealPacketIdx, 1);
					}
					break;	
				case "Case":
					const caseFileIdx = this.selectedCaseFiles.findIndex((file) => file == selectedFile.file);
					if (caseFileIdx !== -1) {
						this.selectedCaseFiles.splice(caseFileIdx, 1);
					}
					break;
				default:
					this.$store.dispatch("notify", {
						variant: "warning",
						title: "Invalid File Source",
						message: `File ${selectedFile.basename} from ${selectedFile.source} was unable to be unselected.`,
					});
					break;
			}
		},
		/**
		 * Portals
		 */
		addedPortal(portal) {
			this.refresh();
		},
		/**
		 * Cover Page
		 */
		savedCoverPage(response) {
			this.$refs.appealFiles.refresh();
			this.refresh();
		},
        
		notesToggele(){
            if(this.toggele==false){
				this.toggele = true;
				
			}else{
				this.toggele=false;
				
			}
		},
		// request tabs 
		handleTabClick(caseRequest) {
			
			this.getSentoName(caseRequest);
			this.getAssigntoName(caseRequest);
		
		if (caseRequest) {
			this.request_name = caseRequest.request_type;
			this.name= caseRequest.name;
			if (caseRequest.user && caseRequest.user.full_name) {
				this.caseassign = caseRequest.user.full_name;
			} else if (caseRequest.user && caseRequest.user.first_name && caseRequest.user.last_name) {
				this.caseassign = caseRequest.user.first_name + ' ' + caseRequest.user.last_name;
			} else {
				this.caseassign = 'Unknown'; // or any default value you prefer
			}

			
			this.showRequestData = true;
			this.entity = {
			name: caseRequest.name || '(No Name)',
			type_label: caseRequest.type_label || '(No Type Label)',
			// status_label: caseRequest.status_label || '(No Status)',
			status_label: caseRequest.request_status || '(No Status)',
			request_status: caseRequest.request_status || '(No Status)',
			insurance_provider: caseRequest.insurance_provider || null,
			agency: caseRequest.agency || null,
			insurance_provider_id: caseRequest.insurance_provider_id || null,
			agency_id: caseRequest.agency_id || null,
			days_due_left: caseRequest.days_due_left || 0,
			due_date: caseRequest.due_date || null,
			completed: caseRequest.completed || false,
			completed_at: caseRequest.completed_at || null,
			created: caseRequest.created || null,
			unable_to_complete: caseRequest.unable_to_complete || false,
			assigned_to_user: caseRequest.assigned_to_user || null,
			assigned_to: caseRequest.assigned_to || null,
			completed_by: caseRequest.completed_by || null,
			id: caseRequest.id || null,
			priority: caseRequest.priority || false,
			day_to_decision: caseRequest.day_to_decision || 0,
			day_to_respond: caseRequest.day_to_respond || 0,
			full_name: (caseRequest.user && caseRequest.user.full_name) ? caseRequest.user.full_name : '-',
			appealname: (caseRequest.appeal && caseRequest.appeal.appeal_level && caseRequest.appeal.appeal_level.name) ? caseRequest.appeal.appeal_level.name : '(No Appeal Name)',
			followUpDate: caseRequest.followUp_date,
			submittedTo: caseRequest.submittedTo,
			status: caseRequest.status,
			urgent: caseRequest.urgent,
			
			};
			this.request_id_for_notes = caseRequest.id;
			this.notesTabName='Notes(Req. ID: '+ caseRequest.id + ')';
			// if (caseRequest.status == 'Closed') {
            //  	this.isEditing = false;
        	// }
			if (this.$authUser.id === caseRequest.submittedTo_ID) {
            	this.isEditing = false;
        	} if (this.$authUser.id === caseRequest.assigned_to &&
            this.$authUser.id === caseRequest.submittedTo_ID
        ) {
			this.isEditing = true;
        } 
		if (this.$authUser.id === caseRequest.created_by
        ) {
            this.isEditing = true;
        } 



			// if(this.$authUser.id===caseRequest.submittedTo_ID) {
			// this.isEditing = false;
			// } else if(this.$authUser.id===caseRequest.assigned_to && this.$authUser.id===caseRequest.submittedTo_ID) {
			// 	this.isEditing = true;
			// } else {
			// 	this.isEditing = true;
			// }
			this.selectedCaseRequestId = caseRequest.id;
			// Ensure request_id is initialized
			if (!this.request_id) {
			this.request_id = [];
			}
			this.request_id.push(caseRequest.id);
			// Optionally handle other logic here
			// this.$refs.appealResponseComponent.generate({ request_id: caseRequest.id });
		} else {
			console.error('Invalid caseRequest:', caseRequest);
		}
		},


		getValidationState,
			cancel() {
				this.$emit("cancel");
				this.reset();
			},
		// hearing save 
		async save(e) {
			try {
				this.saving = true;
				
				const response = await this.$store.dispatch("appeals/save", {
					hearing_date: this.entity.hearing_date,
					hearing_time: this.entity.hearing_time,
					meeting_type: this.entity.meeting_type,
				    address: this.entity.address,
				    phone_number: this.entity.phone_number,
				    conference_url: this.entity.conference_url,
				});

				this.saving = false;
				this.$emit("saved", response);
			} catch (e) {
				
				if (e.response.data.errors) {
					this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
				}

				this.$store.dispatch("apiError", {
					error: e,
					title: "Save Failed",
					message: "Failed to save appeal",
				});
			} finally {
				this.saving = false;
			}
		},
		reset() {
			this.entity = {
			
				hearing_date: null,
				hearing_time: null,
				meeting_type: null,
				address: null,
				phone_number: null,
				conference_url: null,
			};
		},
		//post request
		async hearing() {
			try{
			const url = "/client/hearing";
				
				const response = await axios.post(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});

		}catch (error) {
            console.error("Error fetching data:", error.message);
             }
		},
		async openForm() {

			const response = await axios.get('/client/checkPacketSubmittedStatus', {
				params: {
					caseId: this.appeal.case_id,
					appealLevel: this.appeal.id
				}
			});
			// this.searchResults = response.data;
			if(response.data.hasCompletedSubmitted == false){
				
				this.addingRequest=true;
				this.isAppeal = false;
			}else{

				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "Request",
						message: `A new request cannot be created after an appeal has already been submitted.`,
					});
				});
	
			}
		},
		addedRequest(response) {
			this.addingRequest = false;
			this.isRequest= true;
			this.ispacket = false;
			this.isAppeal = false;
			this.isButton = false;
			this.refresh();
			// this.refreshcaseEntity();
		},
		remove(){
		this.isRequest = false;
		this.ispacket = false;
		this.isAppeal = true;
		this.isButton = true;
		this.request_id_for_notes ='';
		},
		openRequest(){
			this.isButton = false;
			this.isRequest = true;
			this.isAppeal = false;
			this.addingRequest = false;
		},
		initializeData() {
				// Call the hearing method
				this.hearing();
				
				this.caseEntity.appeals.forEach(item => {
					// Get the insurance_appeal_id for the current item
					const insuranceAppealId = item.insurance_appeal_id;

					// Check if the insurance_appeal_id exists in the object, if not, create an empty array
					if (!this.insuranceAppealIdsObject[item.id]) {
						this.$set(this.insuranceAppealIdsObject, item.id, []); // Use $set to ensure reactivity
					}

					// Push the insurance_appeal_id into the array corresponding to the current caseEntity
					this.insuranceAppealIdsObject[item.id].push(insuranceAppealId);
				});

		},
		async destroy(caseRequestId) {
				if (!confirm("Are you sure you want to delete this request?")) {
					return false;
				}

				this.deleting = true;

				try {
					const response = await this.$store.dispatch("caseRequests/delete", {
						case_id: this.$route.params.id,
						id: caseRequestId,
					});

					this.$emit("deleted-request", response);

					var del_msg = null;

					if(response.data.request_type === 'MedicalRecord'){
						del_msg = 'This Medical Records request is deleted.';
					}else{
						del_msg = 'This case request was deleted';
					}

					this.$store.dispatch("notify", {
						variant: "success",
						title: "Request deleted",
						message: del_msg,
						data: response,
					});

					this.$router.push({
						name: "cases.view",
						params: {
							id: this.$route.params.id,
						},
					});
				} catch (e) {
					this.$store.dispatch("apiError", {
						error: e,
						message: "Failed to delete request",
					});
				} finally {
					this.deleting = false;
				}
			},
		async setResponseReceived(caseRequestId){
			axios.post('/client/updateResponseRecieved', {'id': caseRequestId})
			.then(response => {
				// Handle success response
				
				this.saving = false;
				// this.$router.push({
				// 	name: "chains"
				// });
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "primary",
						title: `Response updated`,
						message: "Response Recieved for Request ID- "+caseRequestId,
					});
				});
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
		async fetchAppealClosureReasons() {
			try {
				const url = '/client/api/appealClosureReasons'
				// Fetch data from the server
				const response = await axios.get(url, {
					headers: {
						"Accept": "application/json",
					},
				});
				this.appealClosureReasons = response.data;
			} catch (error) {
				console.error('Error fetching appeal closure reasons:', error);
			}
		},
		// Handle checkbox change
        handleCheckboxChange(reason) {
            if (reason === 'Other' && this.selectedClosureReasons.includes('Other')) {
                this.otherClosureReason = '';
            }
        },
		async outgoingDetails() {
			try {
				const url = window.location.href; 
				const appealId = parseInt(url.match(/\/appeals\/(\d+)/)[1], 10); 
				

				const response = await axios.get("/client/sentOutgoing", {
					headers: { "Accept": "application/json" },
					params: { appealId: appealId }
				});
				
				this.myoutgoing = response.data;
			} catch (error) {
				console.error("Error fetching data:", error.message);
			}
		},
		handleCheckboxCompleteChange(event, entity) {
      		// Get the checked value from the event
      		const isChecked = event.target.checked;
      		this.setRequestAsComplete(isChecked ? '1' : '0', entity.type_label,entity.id);
			},
		setRequestAsComplete(state,type,id) {

			// axios.post('/client/updateResponseRecieved', {'id': this.request_id[this.request_id.length-1]})
			axios.post('/client/updateResponseRecieved', {
				id: id,
				state: state,  // Include the state in the POST request
				type: type  // Include the state in the POST request
			})
			.then(response => {
				// Handle success response
				this.saving = false;
				// this.$router.push({
				// 	name: "chains"
				// });
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "primary",
						message: "Response Recieved for Request ID- "+id,
						title: `Response updated!`,
					});
				});
				// refresh at appeal level
				this.refresh();
				// this.caseEntityrefresh();
				// refresh at request level
				this.refreshcaseEntityStatusMR(id);
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
		handleCheckboxCloseMRChange(event, entity) {
      		// Get the checked value from the event
      		const isChecked = event.target.checked;
      		this.setRequestMRAsClosed(isChecked ? '1' : '0', entity.type_label,entity.id);
			},
			setRequestMRAsClosed(state,type,id) {
			
			// axios.post('/client/updateResponseRecieved', {'id': this.request_id[this.request_id.length-1]})
			axios.post('/client/updateResponseRecievedMRClosed', {
				id: id,
				state: state,  // Include the state in the POST request
				type: type  // Include the state in the POST request
			})
			.then(response => {
				// Handle success response
				this.saving = false;
				// this.$router.push({
				// 	name: "chains"
				// });
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "primary",
						message: "Response Recieved for Request ID- "+id,
						title: `Response updated!`,
					});
				});
				// refresh at appeal level
				this.refresh();
				// this.caseEntityrefresh();
				// refresh at request level
				this.refreshcaseEntityStatusMR(id);
			})
			.catch(error => {
				// Handle error
				console.error(error);
			});
		},
		
		updateDueDate() {
			if(this.entity.day_to_respond == 0 || this.entity.day_to_respond == null || this.entity.day_to_respond == ''){
				this.due_date = this.entity.appeal_letter_date;
			}else{
				this.due_date = moment(this.entity.appeal_letter_date)
				.add(this.entity.day_to_respond, 'days')
				.format('YYYY-MM-DD');
			}
			
		},
		handleToggle() {
			if (this.isOn) {
				this.setRequestAsComplete(1);
			} else {
				this.setRequestAsComplete(0);
			}
		},

		triggerRequestTabClick(caseRequest) {

			const refName = 'request_' + this.$route.params.case_request_id;
			const element = this.$refs[refName];
			this.handleTabClick(caseRequest);

			this.$nextTick(() => {
				const viewRequestElement = this.$refs.viewRequestSection;
				if (viewRequestElement) {
				viewRequestElement.scrollIntoView({
					behavior: 'smooth', // Optional: Adds smooth scrolling
					block: 'start'      // Align to the top of the element
				});
				}
			});
		},

		async fetchDenialTypesAndDenialReasons(){
			const resp = await axios.post('/client/api/getDenialTypeAndDenialReasonForAppeal', {
					'appeal_id':this.$route.params.appeal_id,
			});
			try{
				this.denialData = resp.data;
				this.isDenialDataAvailable = true;
			}
			catch (error) {
                this.isDenialDataAvailable = false;
            }
		},

		async saveDenialData() {
			this.saving = true;
			const resp = await axios.post('/client/api/editDenialTypeAndDenialReasonForAppealForAppeal', {
					'appeal_id':this.appeal.id,
					'denial_type_id':this.denialData.denial_type_id,
					'denial_reason_id':this.denialData.denial_reason_id,
					'case_id':this.appeal.case_id,
			});
			this.saving = false;
			this.isDenialDataAvailable = true;
		},

		isDenialDetailsAdded(){
			if(!this.isPreAppeal){
				return true;
			}
			return this.isDenialDataAvailable;
		},
		checkAppealName(caseEntity , appeal){
			// this.test();
			if(appeal?.is_rebill){
				return appeal.rebill_label?appeal.rebill_label:'Unknown Re-bill Level';
			}
			return appeal?.insurance_provider_appeal_level?.label ?? "Unknown Level";		
		},
		async packetSubmittedAsRebill(resp){
			try{
				const url = '/client/api/updateRebill';
				const resp = await axios.post('/client/api/updateRebill', {
					'appeal_id':this.appeal.id
				});
				if (resp.status === 200) {
					this.$emit("updated", resp);
				}
			}
			catch(error){
				console.error('Error updating rebill for the appeal', error);
			}
		},
		updateDecisionOptionAfterRebill(resp){
			this.updateDecisionOption(
						this.appeal.id,
						'Re-bill',
						0,
						['Re-bill'],
						''
			);
			this.$emit("updated");
		},
		async saveFinancialData() {
			let isValidtotalClaimAmountValidation = true;
			let isValidinitialDenialAmountValidation = true;
			let isValidinitialDisputedAmountValidation = true;
			// Validate 'Total Claim Amount' validation provider
			if (this.$refs.totalClaimAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const totalClaimAmountValidationProviderResult = await this.$refs.totalClaimAmountValidationProvider.validate();
					isValidtotalClaimAmountValidation = totalClaimAmountValidationProviderResult.valid && isValidtotalClaimAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}
			// Validate 'Initial Denial Amount' validation provider
			if (this.$refs.initialDenialAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const initialDenialAmountValidationProviderResult = await this.$refs.initialDenialAmountValidationProvider.validate();
					isValidinitialDenialAmountValidation = initialDenialAmountValidationProviderResult.valid && isValidinitialDenialAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}
			// Validate 'Initial Denial Amount' validation provider
			if (this.$refs.initialDisputedAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const initialDisputedAmountValidationProviderResult = await this.$refs.initialDisputedAmountValidationProvider.validate();
					isValidinitialDisputedAmountValidation = initialDisputedAmountValidationProviderResult.valid && isValidinitialDisputedAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}
			this.appeal.disputed_amount = this.levelName === 'Level I' ? this.caseEntity.disputed_amount : this.appeal.disputed_amount;
			const disputedAmount = Number(this.caseEntity.disputed_amount);
			const leveldisputedAmount = Number(this.appeal.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			if(Number(this.caseEntity.total_claim_amount) < Number(this.caseEntity.disputed_amount)) {
			this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						message: "Initial Denial Amount must be less than or equal to the Total Claim Amount.",
						title: `Error`,
					});
				});
			 return false;
			}
			console.log("this.caseEntity.total_claim_amount = ", this.caseEntity.total_claim_amount)
			console.log("this.appeal.disputed_amount = ", this.appeal.disputed_amount)
			if(Number(this.caseEntity.total_claim_amount) < Number(this.appeal.disputed_amount)) {
				console.log("this.caseEntity.total_claim_amount after= ", this.caseEntity.total_claim_amount)
			console.log("this.appeal.disputed_amount after= ", this.appeal.disputed_amount)
				this.$nextTick(function () {
						this.$store.dispatch("notify", {
							variant: "danger",
							message: "Level Denial Amount must be less than or equal to the Total Claim Amount.",
							title: `Error`,
						});
					});
				return false;
			}
			const disputedAmountToSave =
                    this.levelName === 'Level I' ? this.caseEntity.disputed_amount : this.appeal.disputed_amount;
			if (isValidtotalClaimAmountValidation && isValidinitialDenialAmountValidation && isValidinitialDisputedAmountValidation) {
			this.saving = true;
			try {
				const resp = await axios.post('/client/api/cases/editFinancialData', {
						'appeal_id':this.appeal.id,
						'total_claim_amount':this.caseEntity.total_claim_amount,
						'disputed_amount':this.caseEntity.disputed_amount,
						'disputed_amount_appeal':disputedAmountToSave,
						'contract_risk_amt_actual':this.appeal.contract_risk_amt_actual,
						'contract_risk_Amt_Cal':this.contractRiskAmtCal,
						'case_id':this.appeal.case_id,
						'appeal_level_id': this.appeal.appeal_level_id,
				});
				this.saving = false;
				if(this.caseEntity.total_claim_amount && this.caseEntity.disputed_amount && this.appeal.disputed_amount){
					if(Number(this.caseEntity.total_claim_amount) >= Number(this.caseEntity.disputed_amount) && Number(this.caseEntity.total_claim_amount) >= Number(this.appeal.disputed_amount)){
						this.isFinancialDataAvailable = true;
					}
				}else {
					this.isFinancialDataAvailable = false;
				}
				this.$nextTick(function () {
						this.$store.dispatch("notify", {
							variant: "primary",
							message: "Financial data saved",
							title: `Success`,
						});
					});
							
			} catch (error) {
				// Handle any error that occurs during the API call
				this.saving = false;
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",  // Danger variant for errors
						message: error,
						title: "Error",
					});
				});
			}
    }
			
		},
		formatDisplayNumber(val){
			return parseFloat(val);
		},
		packetGenerated(response){
			this.packetCreated = true;
			this.currPacketName = response.fileName;
			// 
		},
		packetSelected(resp){
			// set flag to indicate packet tab is selected
			this.atPacket = resp;
		},
		isReordered(status, orderedList){
			if(status){
				this.destroyExistingPacket();
			}
		},
		destroyExistingPacket(){
			// if(	this.packetCreated){
			// 	if (!confirm("Are you sure you want to select/deselect items? It will destroy the existing packet.")) {
			// 		this.cancelSelection = true;
			// 		return false;
			// 	}
			// 	if(this.cancelSelection == false){
					this.$refs.appealResponse.activatePacketTab();
					this.packetCreated = false;
			// 	}
				
			// }
		},
		async updateSentDate(){
			try{
				this.isSaved = true;
				if(this.submittedDate){
					const response = await axios.post(`/client/api/appeals/${this.appeal.id}/updateLastSentDate`, {
						modifDate:this.submittedDate
					});
					if(response.data.status){
						this.appeal.submitted = this.submittedDate;
						this.submittedDate = null;
						// Optionally close modal if using b-modal
						this.$bvModal.hide('sent-date-modal');
						this.$bvToast.toast('Last Sent Date updated successfully!', {
							title: 'Success',
							variant: 'success',
							solid: true
						});
					}else{
						this.$bvToast.toast('Update failed', {
							title: 'Error',
							variant: 'danger',
							solid: true
						});
					}
				}
			}catch(e){
				this.$bvToast.toast('Error updating last sent date.', {
					title: 'Error',
					variant: 'danger',
					solid: true
				});
			}
		},
		cancelLastSentEdit(cancel) {
			// this.submittedDate = this.getModifiedLastSentDate();
			this.submittedDate = null;
			cancel();
		},
		onModalClose() {
			if (!this.isSaved) {
				this.submittedDate = null;
			}
			this.isSaved = false; 
		},
		getModifiedLastSentDate(){
			return new Date(this.appeal.submitted).toISOString().split('T')[0]
		}
    },
	watch: {
		// Watch the entity status_label to keep the switch in sync with external changes
		'entity.status_label': function (newValue) {
		this.isOn = newValue === 'Completed';
		},
		'denialData.denial_reason_id': function (newValue, oldValue) {
			if (!this.isPageLoaded) {
				this.showDenialSaveButton = false;
			}else{
				this.showDenialSaveButton = true;
			}
		},
		'denialData.denial_type_id': function (newValue, oldValue) {
			if (!this.isPageLoaded) {
				this.showDenialSaveButton = false;
			}else{
				this.showDenialSaveButton = true;
			}
		},
		'caseEntity': function(newValue, oldValue) {
		 // Your logic here
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.entity.disputed_amount);
		const insuranceRateIndex = this.caseEntity.insuranceRateType;
		
		const pricingSchedule = parseFloat(this.caseEntity.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
	},
	'caseEntity.disputed_amount': function(newValue, oldValue) {
        // Your logic here
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.entity.disputed_amount);
		const insuranceRateIndex = this.caseEntity.insuranceRateType - 1;
		
		const pricingSchedule = parseFloat(this.caseEntity.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
		
    	},
		'entity.disputed_amount': function(newValue, oldValue) {
	    // Your logic here
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.entity.disputed_amount);
		const insuranceRateIndex = this.caseEntity.insuranceRateType - 1;
		
		const pricingSchedule = parseFloat(this.caseEntity.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
		
		}
		
    	},
		'caseEntity.disputed_amount': function(newValue, oldValue) {
		 // Your logic here
		if(this.levelName === 'Level I') {
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.caseEntity.disputed_amount);
		const insuranceRateIndex = this.caseEntity.insuranceRateType - 1;
		
		const pricingSchedule = parseFloat(this.caseEntity.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
		
	}
    	},
		'selectedClosureReasons': function(newValue, oldValue) {
			if ((newValue[0] === 'Re-bill' && oldValue == '') || Array.isArray(newValue) && newValue.length > 0 && (parseInt(this.originalOutstandingAmount) === 0 || this.originalOutstandingAmount == null)) {
				for (let i = 0; i < newValue.length; i++) {
					if (newValue[i] === 'Re-bill' && oldValue == '') {
						this.originalOutstandingAmount = this.appeal.outstanding_amount;
						this.appeal.outstanding_amount = 0;
						this.appeal.appeal_decision = 'Favorable'
						this.shouldUpdateAmount = false;
						break; // Exit loop once condition is met
					}
				}
			}else if(Array.isArray(oldValue) && oldValue.length >0){
				if(this.shouldUpdateAmount == false){
					this.appeal.outstanding_amount = this.originalOutstandingAmount;
				}else{
					this.originalOutstandingAmount = this.appeal.outstanding_amount;
				}
			}
		},
		selectedAppealFiles: {
			handler(newVal, oldVal) {
				// switch to packet tab on response.vue if packet is already is already created and user tries to select/deselect any file
				if(	this.packetCreated && this.cancelSelection == false){
					this.destroyExistingPacket();
				}
			},
			deep: true // important if it's an array of objects
		}
		
	},
	created() {
        this.fetchAppealClosureReasons();
    }
		
};



</script>
<style>
.bg-dark {
    background-color: #343a40 !important;
}

.text-white {
    color: #fff !important;
}
.custom-border {
  border-bottom: 4px solid #d2d2d2; /* Replace with your desired color */
  box-shadow: -3px 6px 3px rgba(0, 0, 0, 0.1);
}

.dropdown.b-dropdown.requestDrpdwn.btn-group .btn.btn-outline-secondary {
    pointer-events: none;
}

.responsive-margin {
    margin-left: -13%; 
	min-width: 413px;
}
.request-button {
		margin-left:1%;
		max-width: 9%;
}
.assign-user {
	margin-left:1%;
}
.level-details{
		margin-top: -14.6px;
	}

@media (max-width: 1280px) {
	.level-details{
		max-width: 17%;
		margin-top: -52.6px;
	}
    .responsive-margin {
        margin-left: -6%; 
    }
	.request-button {
		max-width: 11%;
		margin-left: -6%;
		margin-top: 5%;
	}
	.assign-user {
		margin-right: -12%;
		max-width: 27%;
	}
	.edit-appeal{
		max-width: 20%;
	}
}
.dos-details {
  font-size: 1rem;
}
.badge-updated {
  color: #fff;
  background-color: #9DC183;
}
@media (max-width: 1348px) {
  .dos-details {
    font-size: 0.70rem; 
  }
  .editappeal {
   display: flex;
   min-width: 176px;
   justify-content: space-between;
  }
  .text-urgent {
	color: #ff5252!important;
  }
}

.lastSentDateIcon {
	margin-left:4px;
}

</style>